

// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import BASE_URL from "../../url";

// import {
//   LuLayoutDashboard,
//   LuBriefcase,
//   LuSettings,
//   LuLogOut,
//   LuChevronLeft,
//   LuChevronRight,
//   LuUserCheck,
//   LuUsers,
//   LuFileText,
//   LuChartBar,
//   LuUserPlus,
//   LuSend,
//   LuTarget,
//   LuBarChart,
//   LuStar,
//   LuClock,
//   LuClipboardList,
//   LuFileStack,
//   LuCircleCheck
// } from "react-icons/lu";


// import { FaAngleDown, FaAngleUp, FaThumbtack } from "react-icons/fa";
// import "../styles/Sidebar.css";
// import prophecyLogo2 from "../Assets/images/prophecy-logo2.png";
// import prophecyLogo from "../Assets/images/prophecy-logo.png";
import { useTenant, resolveLogoUrl } from "../../context/TenantContext";

// const Sidebar = () => {
//   const [isPinned, setIsPinned] = useState(localStorage.getItem("sidebarPinned") === "true");
//   const [isHovered, setIsHovered] = useState(false);
//   const [openSubmenu, setOpenSubmenu] = useState(null);
//   const [openBenchSalesSubmenu, setOpenBenchSalesSubmenu] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [isSidebarVisible, setIsSidebarVisible] = useState(true);
//   const sidebarRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Get user role from localStorage
//   const userRole = localStorage.getItem("role");
//   const isExpanded = isPinned || isHovered || isMobile;

//   // Check if user is external user
//   const isExternalUser = userRole === 'External user' || userRole === 'external_user' || userRole === 'external-user';

//   // âœ… CHECK IF USER IS ADMIN FOR H1B ACCESS (ADMIN ONLY)
//   const isAdmin = userRole === 'admin' || userRole === 'super_admin';

//   // âœ… REDIRECT EXTERNAL USERS TO CANDIDATE FORM
//   useEffect(() => {
//     if (isExternalUser && location.pathname !== "/ats") {
//       navigate("/ats?candidateForm=true", { replace: true });
//     }
//   }, [isExternalUser, navigate, location.pathname]);

//   // Handle screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth <= 768;
//       setIsMobile(mobile);
//       if (mobile && isPinned) {
//         setIsSidebarVisible(false);
//       } else {
//         setIsSidebarVisible(true);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [isPinned]);

//   // Save pinned state to localStorage
//   useEffect(() => {
//     localStorage.setItem("sidebarPinned", isPinned);
//   }, [isPinned]);

//   // Handle clicks outside sidebar to close it on mobile
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobile && !isPinned && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setIsSidebarVisible(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isMobile, isPinned]);

//   // Close sidebar when route changes on mobile
//   useEffect(() => {
//     if (isMobile && !isPinned) {
//       setIsSidebarVisible(false);
//     }
//   }, [location, isMobile, isPinned]);

//   // UPDATED LOGOUT FUNCTION WITH TRACKING
//   const handleLogout = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const sessionId = localStorage.getItem('currentSessionId');
      
//       console.log('ðŸšª Manual logout initiated');
      
//       // Track logout if we have a session ID
//       if (sessionId && token) {
//         try {
//           const response = await fetch(`${BASE_URL}/api/auth/track-logout`, {
//             method: "POST",
//             headers: { 
//               "Content-Type": "application/json",
//               "Authorization": `Bearer ${token}`
//             },
//             credentials: 'include',
//             body: JSON.stringify({ trackingId: parseInt(sessionId) })
//           });
          
//           if (response.ok) {
//             console.log('âœ… Logout tracked successfully');
//           } else {
//             console.log('âš ï¸ Logout tracking failed, but continuing...');
//           }
//         } catch (trackError) {
//           console.error("Error tracking logout:", trackError);
//         }
//       }
      
//       // Clear all stored data
//       localStorage.removeItem('token');
//       localStorage.removeItem('username');
//       localStorage.removeItem('role');
//       localStorage.removeItem('id');
//       localStorage.removeItem('user');
//       localStorage.removeItem('firstName');
//       localStorage.removeItem('currentSessionId');
//       localStorage.removeItem('sidebarPinned');
      
//       console.log('ðŸ§¹ Local storage cleared');
      
//       // Navigate to login
//       navigate('/');
      
//     } catch (error) {
//       console.error("Error during logout:", error);
//       localStorage.clear();
//       navigate('/');
//     }
//   };

//   const toggleSidebar = () => {
//     setIsSidebarVisible(!isSidebarVisible);
//   };

//   const toggleSubmenu = (menu) => {
//     setOpenSubmenu(openSubmenu === menu ? null : menu);
//   };

//   const toggleBenchSalesSubmenu = () => {
//     setOpenBenchSalesSubmenu(!openBenchSalesSubmenu);
//   };

//   const isActive = (path) => {
//     if (path.includes('?')) {
//       // Special handling for resume-dashboard to ignore other query params like 't' or 'refresh'
//       if (path.startsWith('/resume-dashboard')) {
//         const currentParams = new URLSearchParams(location.search);
//         const targetParams = new URLSearchParams(path.split('?')[1]);
//         return location.pathname === '/resume-dashboard' && currentParams.get('view') === targetParams.get('view');
//       }
//       return (location.pathname + location.search) === path;
//     }
//     return location.pathname === path;
//   };

//   // Check if current path is recruitment related
//   const isRecruitmentActive = () => {
//     return location.pathname === "/recruitment-dashboard" || 
//            location.pathname === "/recruiter-view" || 
//            location.pathname === "/teamlead-dashboard" ||
//            location.pathname === "/admin-dashboard" ||
//            location.pathname === "/vendor-management";
//   };

//   // Check if current path is ATS related
//   const isATSActive = () => {
//     return location.pathname === "/ats";
//   };

//   // âœ… Check if current path is H1B related (Dashboard or Details only)
//   const isH1BActive = () => {
//     return location.pathname === "/h1b/dashboard" || location.pathname.startsWith("/h1b/submissions/");
//   };

//   // Check if current path is Jobs related
//   const isJobsActive = () => {
//     return location.pathname === "/careers" ;
//   };

//   // Direct navigation to recruitment dashboard based on user role
//   const handleRecruitmentClick = () => {
//     if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
//       navigate("/recruitment-dashboard");
//     } else if (userRole === "user" || userRole === "recruiter") {
//       navigate("/recruiter-view");
//     } else if (userRole === "teamlead" || userRole === "team_lead") {
//       navigate("/teamlead-dashboard");
//     } else {
//       navigate("/recruitment-dashboard");
//     }
//   };

//   // Direct navigation to bench sales dashboard based on user role
//   const handleBenchSalesClick = () => {
//     if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
//       navigate("/bench-sales-dashboard");
//     } else if (userRole === "user") {
//       navigate("/bench-sales-recruiter");
//     } else if (userRole === "teamlead") {
//       navigate("/bench-sales-dashboard");
//     }
//   };

//   const benchSalesMenu = [
//     { path: "/bench-candidates", label: "Candidate Management", icon: <LuUsers size={16} /> },
//     { path: "/bench-requirements", label: "Requirements", icon: <LuFileText size={16} /> },
//     { path: "/bench-submissions", label: "Submissions", icon: <LuSend size={16} /> },
//     { path: "/bench-vendors", label: "Vendors", icon: <LuUsers size={16} /> },
//     { path: "/bench-marketing", label: "Marketing", icon: <LuTarget size={16} /> },
//     { path: "/bench-hotlist", label: "Hotlist", icon: <LuStar size={16} /> },
//   ];

//   // âœ… H1B SUBMENU - ADMIN ONLY (Dashboard and View Details)
//   const h1bMenu = [
//     { path: "/h1b/dashboard", label: "H1B Dashboard", icon: <LuLayoutDashboard size={16} /> },
//     // { path: "/h1b/submissions", label: "View Details", icon: <LuFileStack size={16} /> },
//   ];

//   // Check if ATS should be shown
//   const shouldShowATS = userRole === "admin" || userRole === "super_admin" || userRole === "manager" || userRole === "User" || userRole === "teamlead" || userRole === "team_lead";

//   // Check if Bench Sales should be shown
//   const shouldShowBenchSales = userRole && userRole !== "employee" && !isExternalUser;

//   // âœ… CHECK IF H1B SHOULD BE SHOWN - ADMIN ONLY
//   const shouldShowH1B = isAdmin;

//   // Check if Jobs should be shown - ONLY for external users
//   const shouldShowJobs = isExternalUser;

//   const shouldShowAccounts = userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager";
//   const shouldShowTimesheetApprovals = userRole === "admin" || userRole === "super_admin" || userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || localStorage.getItem('isSupervisor') === 'true';



//   // Menu items based on user role
//   const getMenuItems = () => {
//     // If user is external user, show only Candidate Form (no menu needed, will redirect)
//     if (isExternalUser) {
//       return [
//         { 
//           path: "/ats?candidateForm=true", 
//           label: "Application Form", 
//           icon: <LuBriefcase size={20} />,
//           show: true
//         }
//       ];
//     }

//     // If user is employee, show only Dashboard, Accounts, and Timesheets
//     if (userRole === "employee") {
//       return [
//         { 
//           path: "/home", 
//           label: "Dashboard", 
//           icon: <LuLayoutDashboard size={20} />,
//           show: true
//         },
//         // {
//         //   label: "Accounts",
//         //   icon: <LuFileText size={20} />,
//         //   path: "/accounts",
//         //   show: true
//         // },
//         {
//           label: "Timesheets",
//           icon: <LuClock size={20} />,
//           path: "/timesheets",
//           show: true
//         },
//         {
//           label: "Timesheet Approvals",
//           icon: <LuCircleCheck size={20} />,
//           path: "/timesheet-approvals",
//           show: localStorage.getItem('isSupervisor') === 'true'
//         }

//       ];
//     }


//     // For all other roles, show the full menu
//     const baseItems = [
//       { 
//         path: "/home", 
//         label: "Dashboard", 
//         icon: <LuLayoutDashboard size={20} />,
//         show: true
//       },
//       {
//         path: "/timesheets?mode=internal",
//         label: "My Timesheets",
//         icon: <LuClock size={20} />,
//         show: userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || userRole === "user" || userRole === "admin"
//       }
//     ];

//     // Recruitment submenu
//     const recruitmentSubmenu = [
//       { 
//         path: "/recruitment-dashboard", 
//         label: "Recruitment Dashboard", 
//         icon: <LuLayoutDashboard size={16} />,
//         onClick: handleRecruitmentClick,
//         show: true
//       },
//       { 
//         path: "/vendor-management", 
//         label: "Vendor Management", 
//         icon: <LuUsers size={16} />,
//         onClick: () => navigate("/vendor-management"),
//         show: true
//       }
//     ];

//     const recruitmentItem = {
//       label: "Recruitment",
//       icon: <LuBriefcase size={20} />,
//       submenu: recruitmentSubmenu,
//       show: true
//     };

//     const candidateManagementSubmenu = [
//       { 
//         path: "/resume-dashboard?view=sourcing", 
//         label: "Sourcing", 
//         icon: <LuUserCheck size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=sourcing&t=${Date.now()}`),
//         show: true
//       },
//       { 
//         path: "/resume-dashboard?view=bench", 
//         label: "Bench candidates", 
//         icon: <LuUsers size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=bench&t=${Date.now()}`),
//         show: true
//       },
//       { 
//         path: "/resume-dashboard?view=review", 
//         label: "Need To review", 
//         icon: <LuFileStack size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=review&t=${Date.now()}`),
//         show: true
//       }
//     ];

//     const resumeSubmissionItem = {
//       label: "Candidate Manage",
//       icon: <LuUsers size={20} />,
//       submenu: candidateManagementSubmenu,
//       show: true
//     };

//     const submissionsItem = {
//       path: "/submissions", 
//       label: "Job Submissions", 
//       icon: <LuSend size={20} />,
//       show: true
//     };

//     const atsItem = {
//       path: "/ats",
//       label: "ATS",
//       icon: <LuClipboardList size={20} />,
//       show: shouldShowATS
//     };

//     // âœ… H1B ITEM - ADMIN ONLY (with submenu)
//     const h1bItem = {
//       label: "H1B Management",
//       icon: <LuFileStack size={20} />,
//       submenu: h1bMenu,
//       show: shouldShowH1B
//     };

//     // const msaItem = {
//     //   path: "/msa",
//     //   label: "MSA",
//     //   icon: <LuFileText size={20} />,
//     //   show: userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager"
//     // };

//     const adminItems = [
//       {
//         label: "User Management",
//         icon: <LuUsers size={20} />,
//         path: "/user-management",
//         show: userRole === "admin" || userRole === "super_admin"
//       },
//       {
//         label: "Accounting",
//         icon: <LuFileText size={20} />,
//         path: "/companies",
//         show: shouldShowAccounts
//       },
//       {
//         label: "Invoices",
//         icon: <LuFileText size={20} />,
//         path: "/invoices",
//         show: shouldShowAccounts
//       },
//       {
//         label: "Onboarding",
//         icon: <LuUserPlus size={20} />,
//         path: "/onboarding",
//         show: userRole === "admin" || userRole === "super_admin"
//       },
//       {
//         label: "Timesheet Approvals",
//         icon: <LuClock size={20} />,
//         path: "/timesheet-approvals",
//         show: shouldShowTimesheetApprovals
//       }
//     ];

//     return [
//       ...baseItems,
//       recruitmentItem,
//       resumeSubmissionItem,
//       submissionsItem,
//       atsItem,
//       h1bItem,  // âœ… ADDED H1B ITEM WITH SUBMENU
//       // msaItem,  // âœ… ADDED MSA ITEM
//       ...adminItems.filter(item => item.show)
//     ];
//   };

//   const menuItems = getMenuItems();

//   return (
//     <>
//       {/* Mobile Toggle Button - Outside Sidebar */}
//       {isMobile && (
//         <button
//           className={`sidebar-toggle ${isSidebarVisible ? 'open' : ''}`}
//           onClick={toggleSidebar}
//           aria-label="Toggle sidebar"
//         >
//           {isSidebarVisible ? <LuChevronLeft /> : <LuChevronRight />}
//         </button>
//       )}

//       <div className={`sidebar-overlay ${isMobile && isSidebarVisible ? 'visible' : ''}`} onClick={() => setIsSidebarVisible(false)}></div>

//       <div className="Mainsidebar-container">
//         <div
//           ref={sidebarRef}
//           className={`sidebar ${isExpanded ? "expanded" : "collapsed"} ${isSidebarVisible ? "visible" : "hidden"}`}
//           onMouseEnter={() => !isMobile && !isPinned && setIsHovered(true)}
//           onMouseLeave={() => !isMobile && !isPinned && setIsHovered(false)}
//         >
//           {/* Sidebar Header */}
//           <div className="sidebar-header">
//             <div className="logo-container">
//               <img src={prophecyLogo2} alt="Logo" className="initial-logo" />
//               {isExpanded && <img src={prophecyLogo} alt="Logo" className="logo" />}
//             </div>

//             {/* Pin Button - Only show on desktop */}
//             {isExpanded && !isMobile && (
//               <button className="pin-button" onClick={() => setIsPinned(!isPinned)} aria-label={isPinned ? "Unpin sidebar" : "Pin sidebar"}>
//                 <FaThumbtack className={`pin-icon ${isPinned ? "pinned" : ""}`} />
//               </button>
//             )}

//             {/* Close Button - Only show on mobile */}
//             {isExpanded && isMobile && (
//               <button className="close-button" onClick={() => setIsSidebarVisible(false)} aria-label="Close sidebar">
//                 <LuChevronLeft />
//               </button>
//             )}
//           </div>

//           {/* Sidebar Menu */}
//           <nav>
//             <ul className="menu">
//               {menuItems.map((item, index) => {
//                 if (!item.show) return null;

//                 if (item.submenu) {
//                   return (
//                     <React.Fragment key={index}>
//                       <li
//                         className={`menu-item ${openSubmenu === item.label ? "open" : ""} ${item.submenu.some(subItem => isActive(subItem.path)) ? "active" : ""}`}
//                         onClick={() => toggleSubmenu(item.label)}
//                       >
//                         {item.icon}
//                         {isExpanded && <span className="menu-text">{item.label}</span>}
//                         {isExpanded && item.submenu && (
//                           <span className="submenu-icon">
//                             {openSubmenu === item.label ? <FaAngleUp /> : <FaAngleDown />}
//                           </span>
//                         )}
//                         {item.submenu.some(subItem => isActive(subItem.path)) && <span className="active-indicator"></span>}
//                       </li>

//                       {isExpanded && openSubmenu === item.label && (
//                         <ul className="submenu">
//                           {item.submenu.filter(subItem => subItem.show !== false).map((subItem, subIndex) => (
//                             <li
//                               key={subIndex}
//                               className={`submenu-item ${isActive(subItem.path) ? "active" : ""}`}
//                               onClick={subItem.onClick ? subItem.onClick : () => navigate(subItem.path)}
//                             >
//                               <span className="submenu-icon">{subItem.icon}</span>
//                               <span className="submenu-text">{subItem.label}</span>
//                               {isActive(subItem.path) && <span className="active-indicator"></span>}
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </React.Fragment>
//                   );
//                 } else {
//                   return (
//                     <li
//                       key={index}
//                       className={`menu-item ${item.onClick && isRecruitmentActive() ? "active" : isActive(item.path) ? "active" : ""}`}
//                       onClick={item.onClick ? item.onClick : () => navigate(item.path)}
//                     >
//                       {item.icon}
//                       {isExpanded && <span className="menu-text">{item.label}</span>}
//                       {(item.onClick && isRecruitmentActive()) || (item.path === "/ats" && isATSActive()) || (item.path === "/jobs" && isJobsActive()) || isActive(item.path) ? <span className="active-indicator"></span> : null}
//                     </li>
//                   );
//                 }
//               })}

//               {/* Bench Sales Submenu - Only show if user is not employee and not external user */}
//               {shouldShowBenchSales && (
//                 <li
//                   className={`menu-item ${openBenchSalesSubmenu ? "open" : ""} ${location.pathname.includes("/bench-") || location.pathname === "/bench-sales" ? "active" : ""}`}
//                   onClick={toggleBenchSalesSubmenu}
//                 >
//                   <LuChartBar size={20} />
//                   {isExpanded && <span className="menu-text">Bench Sales</span>}
//                   {isExpanded && (
//                     <span className="submenu-icon">
//                       {openBenchSalesSubmenu ? <FaAngleUp /> : <FaAngleDown />}
//                     </span>
//                   )}
//                   {(location.pathname.includes("/bench-") || location.pathname === "/bench-sales") && <span className="active-indicator"></span>}
//                 </li>
//               )}
              
//               {/* Bench Sales Submenu Items - Only show if user is not employee and not external user */}
//               {shouldShowBenchSales && isExpanded && openBenchSalesSubmenu && (
//                 <ul className="submenu">
//                   <li
//                     className={`submenu-item ${isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter") ? "active" : ""}`}
//                     onClick={handleBenchSalesClick}
//                   >
//                     <span className="submenu-icon"><LuLayoutDashboard size={16} /></span>
//                     <span className="submenu-text">Bench Sales Dashboard</span>
//                     {(isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter")) && <span className="active-indicator"></span>}
//                   </li>
//                   {benchSalesMenu.map((item, index) => (
//                     <li
//                       key={index}
//                       className={`submenu-item ${isActive(item.path) ? "active" : ""}`}
//                       onClick={(e) => {
//                         e.preventDefault();
//                         e.stopPropagation();
//                         navigate(item.path);
//                       }}
//                     >
//                       <span className="submenu-icon">{item.icon}</span>
//                       <span className="submenu-text">{item.label}</span>
//                       {isActive(item.path) && <span className="active-indicator"></span>}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </ul>
//           </nav>

//           {/* Settings & Logout - Only show if user is logged in */}
//           {userRole && (
//             <div className="settings-section">
//               <ul>
//                 {!isExternalUser && (
//                   <li className={isActive("/settings") ? "active" : ""} onClick={() => navigate("/settings")}>
//                     <LuSettings size={20} />
//                     {isExpanded && <span className="menu-text">Settings</span>}
//                     {isActive("/settings") && <span className="active-indicator"></span>}
//                   </li>
//                 )}
//                 <li onClick={handleLogout}>
//                   <LuLogOut size={20} />
//                   {isExpanded && <span className="menu-text">Log Out</span>}
//                 </li>
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BASE_URL from "../../url";

import {
  LuLayoutDashboard,
  LuBriefcase,
  LuSettings,
  LuLogOut,
  LuChevronLeft,
  LuChevronRight,
  LuUserCheck,
  LuUsers,
  LuBuilding,
  LuFileText,
  LuChartBar,
  LuUserPlus,
  LuSend,
  LuTarget,
  LuBarChart,
  LuStar,
  LuClock,
  LuClipboardList,
  LuFileStack,
  LuCircleCheck,
  LuCalendar,
  LuUser,
  LuFlame
} from "react-icons/lu";


import { FaAngleDown, FaAngleUp, FaThumbtack } from "react-icons/fa";
import "../styles/Sidebar.css";
import prophecyLogo2 from "../Assets/images/prophecy-logo2.png";
import prophecyLogo from "../Assets/images/prophecy-logo.png";

const Sidebar = ({ isPinned: propIsPinned, togglePinned }) => {
  const { companyId, companyName, logoUrl, allowedModules } = useTenant();
  const [sidebarLogoFailed, setSidebarLogoFailed] = useState(false);

  useEffect(() => {
    setSidebarLogoFailed(false);
  }, [logoUrl]);

  const [isPinned, setIsPinned] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [openNestedSubmenu, setOpenNestedSubmenu] = useState(null);
  const [openBenchSalesSubmenu, setOpenBenchSalesSubmenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Clear any old stale collapsed state from localStorage so it always defaults open
  useEffect(() => {
    try {
      localStorage.removeItem("sidebarPinned");
    } catch (e) {}
  }, []);

  useEffect(() => {
    if (propIsPinned !== undefined) {
      setIsPinned(propIsPinned);
    }
  }, [propIsPinned]);

  const handleTogglePin = () => {
    setIsPinned(prev => !prev);
    if (typeof togglePinned === 'function') {
      togglePinned();
    }
  };

  // Get user role from localStorage with safe lowercase normalization
  const rawUserRole = localStorage.getItem("role") || "";
  const userRole = rawUserRole.toLowerCase().trim();
  const isExpanded = isPinned || isHovered || isMobile;

  // Check if user is external user
  const isExternalUser = userRole === 'external user' || userRole === 'external_user' || userRole === 'external-user' || userRole === 'external';

  // âœ… CHECK IF USER IS ADMIN FOR H1B ACCESS (ADMIN ONLY)
  const isAdmin = userRole === 'admin' || userRole === 'super_admin';

  // Role & User Menu Permissions synchronization
  const [rolePermissions, setRolePermissions] = useState(() => {
    try {
      const saved = localStorage.getItem('erp_role_menu_permissions');
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  });

  const [userPermissions, setUserPermissions] = useState(() => {
    try {
      const saved = localStorage.getItem('erp_user_menu_permissions');
      return saved ? JSON.parse(saved) : null;
    } catch (e) {
      return null;
    }
  });

  // Track if timesheet is required for the logged-in user
  const [isTimesheetRequired, setIsTimesheetRequired] = useState(() => {
    try {
      const saved = localStorage.getItem('erp_timesheet_required');
      return saved !== null ? saved === 'true' : true;
    } catch (e) {
      return true;
    }
  });

  useEffect(() => {
    let isMounted = true;
    const loggedInUserId = localStorage.getItem('id');

    const fetchUserPermissions = async () => {
      if (!loggedInUserId) return;
      try {
        const response = await fetch(`${BASE_URL}/api/auth/user-permissions/${loggedInUserId}?_t=${Date.now()}`);
        const data = await response.json();
        if (data && data.success) {
          if (Array.isArray(data.permissions)) {
            if (isMounted) {
              setUserPermissions(data.permissions);
              localStorage.setItem('erp_user_menu_permissions', JSON.stringify(data.permissions));
            }
          } else if (data.permissions === null || !data.permissions) {
            if (isMounted) {
              setUserPermissions(null);
              localStorage.removeItem('erp_user_menu_permissions');
            }
          }
        }
      } catch (err) {}
    };

    const fetchRolePermissions = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/auth/role-permissions?_t=${Date.now()}`);
        const data = await response.json();
        if (data && data.success && data.permissions && Object.keys(data.permissions).length > 0) {
          if (isMounted) {
            setRolePermissions(data.permissions);
            localStorage.setItem('erp_role_menu_permissions', JSON.stringify(data.permissions));
          }
        }
      } catch (err) {
        // Safe fallback
      }
    };

    const fetchTimesheetRequirement = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      try {
        const response = await fetch(`${BASE_URL}/api/timesheets/check-editing-permission`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await response.json();
        if (data && data.success) {
          const req = data.timesheetRequired !== false;
          if (isMounted) {
            setIsTimesheetRequired(req);
            localStorage.setItem('erp_timesheet_required', req ? 'true' : 'false');
          }
        }
      } catch (err) {}
    };

    fetchUserPermissions();
    fetchRolePermissions();
    fetchTimesheetRequirement();

    const handlePermsUpdate = () => {
      try {
        const savedUser = localStorage.getItem('erp_user_menu_permissions');
        if (savedUser && isMounted) setUserPermissions(JSON.parse(savedUser));
        const savedRole = localStorage.getItem('erp_role_menu_permissions');
        if (savedRole && isMounted) setRolePermissions(JSON.parse(savedRole));
        const savedReq = localStorage.getItem('erp_timesheet_required');
        if (savedReq !== null && isMounted) setIsTimesheetRequired(savedReq === 'true');
      } catch (e) {}
    };

    const handleFocus = () => {
      handlePermsUpdate();
      fetchUserPermissions();
      fetchRolePermissions();
      fetchTimesheetRequirement();
    };

    let bc = null;
    try {
      if (typeof BroadcastChannel !== 'undefined') {
        bc = new BroadcastChannel('erp_role_permissions_channel');
        bc.onmessage = (event) => {
          if (event.data) {
            if (event.data.type === 'USER_PERMISSIONS_UPDATED' && String(event.data.userId) === String(loggedInUserId)) {
              if (isMounted) {
                setUserPermissions(event.data.permissions);
                localStorage.setItem('erp_user_menu_permissions', JSON.stringify(event.data.permissions));
              }
            } else if (event.data.type === 'PERMISSIONS_UPDATED' && event.data.permissions) {
              if (isMounted) {
                setRolePermissions(event.data.permissions);
                localStorage.setItem('erp_role_menu_permissions', JSON.stringify(event.data.permissions));
              }
            }
          }
        };
      }
    } catch (e) {}

    const handleTimesheetRequiredUpdate = () => {
      fetchTimesheetRequirement();
    };

    window.addEventListener('rolePermissionsUpdated', handlePermsUpdate);
    window.addEventListener('storage', handlePermsUpdate);
    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleFocus);
    window.addEventListener('timesheetRequiredUpdated', handleTimesheetRequiredUpdate);

    // Periodic sync: ensure any permissions or timesheet requirements updated reflect automatically
    const pollInterval = setInterval(() => {
      if (typeof document !== 'undefined' && !document.hidden) {
        fetchUserPermissions();
        fetchRolePermissions();
        fetchTimesheetRequirement();
      }
    }, 3000);

    return () => {
      isMounted = false;
      clearInterval(pollInterval);
      window.removeEventListener('rolePermissionsUpdated', handlePermsUpdate);
      window.removeEventListener('storage', handlePermsUpdate);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleFocus);
      window.removeEventListener('timesheetRequiredUpdated', handleTimesheetRequiredUpdate);
      if (bc) {
        try { bc.close(); } catch (e) {}
      }
    };
  }, []);

  // Route guard: if employee loses permission to /companies, redirect immediately to /timesheets
  useEffect(() => {
    if (userRole === "employee" && location.pathname === "/companies") {
      let activeMap = rolePermissions;
      if (!activeMap) {
        try {
          const saved = localStorage.getItem('erp_role_menu_permissions');
          if (saved) activeMap = JSON.parse(saved);
        } catch (e) {}
      }
      if (activeMap) {
        const matchedKey = Object.keys(activeMap).find(k => k.toLowerCase().trim() === "employee");
        const customPerms = matchedKey && Array.isArray(activeMap[matchedKey]) ? activeMap[matchedKey] : null;
        if (customPerms && !customPerms.includes("hrm_accounting")) {
          navigate("/timesheets", { replace: true });
        }
      }
    }
  }, [location.pathname, rolePermissions, userRole, navigate]);

  // âœ… REDIRECT EXTERNAL USERS TO CANDIDATE FORM
  useEffect(() => {
    if (isExternalUser && location.pathname !== "/ats") {
      navigate("/ats?candidateForm=true", { replace: true });
    }
  }, [isExternalUser, navigate, location.pathname]);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile && isPinned) {
        setIsSidebarVisible(false);
      } else {
        setIsSidebarVisible(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isPinned]);

  // Handle clicks outside sidebar to close it on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && !isPinned && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setIsSidebarVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobile, isPinned]);

  // Close sidebar when route changes on mobile
  useEffect(() => {
    if (isMobile && !isPinned) {
      setIsSidebarVisible(false);
    }
  }, [location, isMobile, isPinned]);

  // Auto open HRM menu when visiting HRM routes (nested Onboarding stays closed by default)
  useEffect(() => {
    if (
      location.pathname === "/onboarding" || 
      location.pathname === "/onboarding-report" ||
      location.pathname === "/deployment-report" ||
      location.pathname === "/companies"
    ) {
      setOpenSubmenu("HRM");
    }
  }, [location.pathname]);

  // UPDATED LOGOUT FUNCTION WITH TRACKING
  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('token');
      const sessionId = localStorage.getItem('currentSessionId');
      
      console.log('ðŸšª Manual logout initiated');
      
      // Track logout if we have a session ID
      if (sessionId && token) {
        try {
          const response = await fetch(`${BASE_URL}/api/auth/track-logout`, {
            method: "POST",
            headers: { 
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`
            },
            credentials: 'include',
            body: JSON.stringify({ trackingId: parseInt(sessionId) })
          });
          
          if (response.ok) {
            console.log('âœ… Logout tracked successfully');
          } else {
            console.log('âš ï¸ Logout tracking failed, but continuing...');
          }
        } catch (trackError) {
          console.error("Error tracking logout:", trackError);
        }
      }
      
      // Clear all stored data
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('id');
      localStorage.removeItem('user');
      localStorage.removeItem('firstName');
      localStorage.removeItem('currentSessionId');
      localStorage.removeItem('sidebarPinned');
      localStorage.removeItem('company_id');
      localStorage.removeItem('saas_company_id');
      
      // Clear all persisted filter states saved by usePersistentFilters hook
      sessionStorage.clear();
      
      console.log('ðŸ§¹ Local storage cleared');
      
      // Navigate to login
      navigate('/');
      
    } catch (error) {
      console.error("Error during logout:", error);
      localStorage.clear();
      sessionStorage.clear();
      navigate('/');
    }
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const toggleBenchSalesSubmenu = () => {
    setOpenBenchSalesSubmenu(!openBenchSalesSubmenu);
  };

  const isActive = (path) => {
    if (path.includes('?')) {
      // Special handling for resume-dashboard to ignore other query params like 't' or 'refresh'
      if (path.startsWith('/resume-dashboard')) {
        const currentParams = new URLSearchParams(location.search);
        const targetParams = new URLSearchParams(path.split('?')[1]);
        return location.pathname === '/resume-dashboard' && currentParams.get('view') === targetParams.get('view');
      }
      return (location.pathname + location.search) === path;
    }
    if (path === '/track-status') {
      return location.pathname === '/track-status' || location.pathname === '/profile';
    }
    return location.pathname === path;
  };

  // Check if current path is recruitment related
  const isRecruitmentActive = () => {
    return location.pathname === "/recruitment-dashboard" || 
           location.pathname === "/recruiter-view" || 
           location.pathname === "/teamlead-dashboard" ||
           location.pathname === "/admin-dashboard" ||
           location.pathname === "/vendor-management";
  };

  // Check if current path is ATS related
  const isATSActive = () => {
    return location.pathname === "/ats";
  };

  // âœ… Check if current path is H1B related (Dashboard or Details only)
  const isH1BActive = () => {
    return location.pathname === "/h1b/dashboard" || location.pathname.startsWith("/h1b/submissions/");
  };

  // Check if current path is Jobs related
  const isJobsActive = () => {
    return location.pathname === "/careers" ;
  };

  // Direct navigation to recruitment dashboard based on user role
  const handleRecruitmentClick = () => {
    if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
      navigate("/recruitment-dashboard");
    } else if (userRole === "user" || userRole === "recruiter") {
      navigate("/recruiter-view");
    } else if (userRole === "teamlead" || userRole === "team_lead") {
      navigate("/teamlead-dashboard");
    } else {
      navigate("/recruitment-dashboard");
    }
  };

  // Direct navigation to bench sales dashboard based on user role
  const handleBenchSalesClick = () => {
    if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
      navigate("/bench-sales-dashboard");
    } else if (userRole === "user") {
      navigate("/bench-sales-recruiter");
    } else if (userRole === "teamlead") {
      navigate("/bench-sales-dashboard");
    }
  };

  const benchSalesMenu = [
    { path: "/bench-candidates", label: "Candidate Management", icon: <LuUsers size={16} /> },
    { path: "/bench-requirements", label: "Requirements", icon: <LuFileText size={16} /> },
    { path: "/bench-submissions", label: "Submissions", icon: <LuSend size={16} /> },
    { path: "/bench-vendors", label: "Vendors", icon: <LuUsers size={16} /> },
    { path: "/bench-marketing", label: "Marketing", icon: <LuTarget size={16} /> },
    { path: "/bench-hotlist", label: "Hotlist", icon: <LuStar size={16} /> },
  ];

  // âœ… H1B SUBMENU - ADMIN ONLY (Dashboard and View Details)
  const h1bMenu = [
    { path: "/h1b/dashboard", label: "H1B Dashboard", icon: <LuLayoutDashboard size={16} /> },
    // { path: "/h1b/submissions", label: "View Details", icon: <LuFileStack size={16} /> },
  ];

  // Check if ATS should be shown
  const shouldShowATS = ["admin", "super_admin", "manager", "user", "User", "teamlead", "team_lead", "recruiter"].includes(userRole);

  // Check if Bench Sales should be shown
  const shouldShowBenchSales = false;

  // âœ… CHECK IF H1B SHOULD BE SHOWN - ADMIN ONLY
  const shouldShowH1B = isAdmin;

  // Check if Jobs should be shown - ONLY for external users
  const shouldShowJobs = isExternalUser;

  const shouldShowAccounts = userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager";
  const shouldShowTimesheetApprovals = userRole === "admin" || userRole === "super_admin" || userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || localStorage.getItem('isSupervisor') === 'true';



  // Menu items based on user role
  const getMenuItems = () => {
    // If user is external user, show only Candidate Form (no menu needed, will redirect)
    if (isExternalUser) {
      return [
        { 
          path: "/ats?candidateForm=true", 
          label: "Application Form", 
          icon: <LuBriefcase size={20} />,
          show: true
        }
      ];
    }

    // 1. First priority: Check if this individual person has their own user-level menu permissions configured
    let activeUserPerms = userPermissions;
    if (!activeUserPerms || !Array.isArray(activeUserPerms)) {
      try {
        const savedUser = localStorage.getItem('erp_user_menu_permissions');
        if (savedUser) activeUserPerms = JSON.parse(savedUser);
      } catch (e) {}
    }

    // 2. Synchronous fallback to role permissions if no user-level permissions exist
    let activePermsMap = rolePermissions;
    if (!activePermsMap || typeof activePermsMap !== 'object') {
      try {
        const saved = localStorage.getItem('erp_role_menu_permissions');
        if (saved) activePermsMap = JSON.parse(saved);
      } catch (e) {}
    }

    // Case-insensitive role lookup in permissions map
    const matchedRoleKey = activePermsMap ? Object.keys(activePermsMap).find(k => k.toLowerCase().trim() === userRole) : null;
    const rolePerms = matchedRoleKey && Array.isArray(activePermsMap[matchedRoleKey]) ? activePermsMap[matchedRoleKey] : null;

    // Active permissions: User-level permissions take highest priority over role permissions
    const customPermsForRole = (Array.isArray(activeUserPerms) && activeUserPerms.length > 0)
      ? activeUserPerms
      : rolePerms;

    // If user is employee AND has NO custom permissions configured, show default employee menu
    if (userRole === "employee" && !customPermsForRole) {
      return [
        { 
          path: "/home", 
          label: "Dashboard", 
          icon: <LuLayoutDashboard size={20} />,
          show: false
        },
        // {
        //   path: "/track-status",
        //   label: "Profile",
        //   icon: <LuUser size={20} />,
        //   show: true
        // },
        {
          label: "Timesheets",
          icon: <LuClock size={20} />,
          path: "/timesheets",
          show: isTimesheetRequired
        },
        {
          label: "Leave Manage",
          icon: <LuCalendar size={20} />,
          path: "/leave-manage",
          show: true
        },
        {
          label: "Timesheet Approvals",
          icon: <LuCircleCheck size={20} />,
          path: "/timesheet-approvals",
          show: localStorage.getItem('isSupervisor') === 'true'
        }
      ];
    }

    // For all other roles (or employee with custom permissions), show the full menu
    const baseItems = [
      { 
        path: "/home", 
        label: "Dashboard", 
        icon: <LuLayoutDashboard size={20} />,
        show: false
      },
      // {
      //   path: "/track-status",
      //   label: "Profile",
      //   icon: <LuUser size={20} />,
      //   show: userRole === "employee"
      // },
      {
        path: userRole === "employee" ? "/timesheets" : "/timesheets?mode=internal",
        label: userRole === "employee" ? "Timesheets" : "My Timesheets",
        icon: <LuClock size={20} />,
        show: isTimesheetRequired && (customPermsForRole ? true : (userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || userRole === "user" || userRole === "admin" || userRole === "employee"))
      },
      {
        path: "/leave-manage",
        label: "Leave Manage",
        icon: <LuCalendar size={20} />,
        show: true
      }
    ];

    const recruitmentSubmenu = [
      { 
        path: "/recruitment-dashboard", 
        label: "Recruitment Dashboard", 
        icon: <LuLayoutDashboard size={16} />,
        onClick: handleRecruitmentClick,
        show: true
      }
    ];

    const crmSubmenu = [
      {
        path: "/crm/companies",
        label: "Vendor & Client",
        icon: <LuUsers size={16} />,
        onClick: () => navigate("/crm/companies"),
        show: true
      },
      {
        path: "/crm/msa-po",
        label: "MSA & PO",
        icon: <LuFileText size={16} />,
        onClick: () => navigate("/crm/msa-po"),
        show: true
      }
    ];

    const crmItem = {
      label: "CRM",
      icon: <LuBuilding size={20} />,
      submenu: crmSubmenu,
      show: userRole === "admin" || userRole === "super_admin"
    };

    const hrmSubmenu = [
      {
        path: "/companies",
        label: "Accounting",
        icon: <LuFileText size={16} />,
        show: shouldShowAccounts
      },
      {
        label: "Onboarding",
        icon: <LuUserPlus size={16} />,
        show: userRole === "admin" || userRole === "super_admin" || shouldShowAccounts,
        submenu: [
          {
            path: "/onboarding",
            label: "Dashboard",
            icon: <LuLayoutDashboard size={14} />,
            show: true
          },
          {
            path: "/onboarding-report",
            label: "Onboarding Report",
            icon: <LuClipboardList size={14} />,
            show: true
          }
        ]
      },
      {
        path: "/deployment-report",
        label: "Deployment Report",
        icon: <LuBriefcase size={16} />,
        show: userRole === "admin" || userRole === "super_admin" || shouldShowAccounts
      }
    ];

    const hrmItem = {
      label: "HRM",
      icon: <LuUserCheck size={20} />,
      submenu: hrmSubmenu,
      show: userRole === "admin" || userRole === "super_admin" || shouldShowAccounts
    };

    const recruitmentItem = {
      label: "Recruitment",
      icon: <LuBriefcase size={20} />,
      submenu: recruitmentSubmenu,
      show: true
    };

    const candidateManagementSubmenu = [
      { 
        path: "/resume-dashboard?view=sourcing", 
        label: "Sourcing", 
        icon: <LuUserCheck size={16} />,
        onClick: () => navigate('/resume-dashboard?view=sourcing'),
        show: true
      },
      { 
        path: "/resume-dashboard?view=bench", 
        label: "Bench candidates", 
        icon: <LuUsers size={16} />,
        onClick: () => navigate('/resume-dashboard?view=bench'),
        show: true
      },
      { 
        path: "/resume-dashboard?view=review", 
        label: "Need To review", 
        icon: <LuFileStack size={16} />,
        onClick: () => navigate('/resume-dashboard?view=review'),
        show: true
      }
    ];

    const resumeSubmissionItem = {
      label: "Candidate Manage",
      icon: <LuUsers size={22} />,
      submenu: candidateManagementSubmenu,
      show: true
    };

    const jobSubmissionsSubmenu = [
      {
        path: "/submissions",
        label: "Dashboard",
        icon: <LuSend size={16} />,
        show: true
      },
      {
        path: "/job-report",
        label: "Submission Report",
        icon: <LuFileStack size={16} />,
        show: true
      },
      {
        path: "/job-count-report",
        label: "Job Report",
        icon: <LuChartBar size={16} />,
        show: true
      },
      {
        path: "/client-count",
        label: "Client Report",
        icon: <LuBuilding size={16} />,
        show: true
      },
      {
        path: "/performance-report",
        label: "Performance Report",
        icon: <LuChartBar size={16} />,
        show: true
      }
    ];

    const submissionsItem = {
      label: "Job Submissions", 
      icon: <LuSend size={20} />,
      submenu: jobSubmissionsSubmenu,
      show: true
    };

    const atsItem = {
      path: "/ats",
      label: "ATS",
      icon: <LuClipboardList size={20} />,
      show: shouldShowATS
    };

    // âœ… H1B ITEM - ADMIN ONLY (with submenu)
    const h1bItem = {
      label: "H1B Management",
      icon: <LuFileStack size={20} />,
      submenu: h1bMenu,
      show: shouldShowH1B
    };

    // âœ… BENCH MANAGE ITEM
    const benchManageSubmenu = [
      {
        path: "/resume-dashboard?view=bench",
        label: "Bench Candidates",
        icon: <LuUsers size={16} />,
        show: true
      },
      {
        path: "/bench-manage/dashboard",
        label: "Dashboard",
        icon: <LuLayoutDashboard size={16} />,
        show: true
      },
      {
        path: "/bench-manage/submissions",
        label: "Submission",
        icon: <LuSend size={16} />,
        show: true
      },
      {
        path: "/bench-manage/reports",
        label: "Bench Report",
        icon: <LuChartBar size={16} />,
        show: true
      },
      {
        path: "/bench-heat-report",
        label: "Bench Heat Report",
        icon: <LuFlame size={16} />,
        show: true
      }
    ];

    const benchManageItem = {
      label: "Bench Manage",
      icon: <LuUsers size={20} />,
      submenu: benchManageSubmenu,
      show: !isExternalUser
    };

    // const msaItem = {
    //   path: "/msa",
    //   label: "MSA",
    //   icon: <LuFileText size={20} />,
    //   show: userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager"
    // };

    const adminItems = [
      {
        label: "Tenant Management",
        icon: <LuBuilding size={20} />,
        path: "/tenant-management",
        show: isCompanyProphecy && (userRole === "admin" || userRole === "super_admin")
      },
      {
        label: "User Management",
        icon: <LuUsers size={20} />,
        path: "/user-management",
        show: userRole === "admin" || userRole === "super_admin"
      },
      {
        label: "Invoices",
        icon: <LuFileText size={20} />,
        path: "/invoices",
        show: shouldShowAccounts
      },
      {
        label: "Timesheet Approvals",
        icon: <LuClock size={20} />,
        path: "/timesheet-approvals",
        show: shouldShowTimesheetApprovals
      }
    ];

    const allConstructedItems = [
      ...baseItems,
      recruitmentItem,
      submissionsItem,
      resumeSubmissionItem,
      benchManageItem,
      crmItem,
      hrmItem,
      atsItem,
      h1bItem,  // âœ… ADDED H1B ITEM WITH SUBMENU
      ...(customPermsForRole ? adminItems : adminItems.filter(item => item.show))
    ];

    // Helper for key normalization
    const toMenuKey = (label) => {
      if (!label) return '';
      return label.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    };

    const KNOWN_KEY_MAP = {
      "my timesheets": "timesheets",
      "timesheets": "timesheets",
      "leave manage": "leave_manage",
      "profile": "track_status",
      "recruitment": "recruitment_dashboard",
      "recruitment dashboard": "recruitment_dashboard",
      "dashboard": "submissions",
      "submission report": "job_report",
      "job report": "job_count_report",
      "client report": "client_count",
      "performance report": "performance_report",
      "sourcing": "candidate_sourcing",
      "bench candidates": "candidate_bench",
      "need to review": "candidate_review",
      "bench dashboard": "bench_dashboard",
      "submission": "bench_submissions",
      "bench report": "bench_reports",
      "bench heat report": "bench_heat_report",
      "vendor & client": "crm_companies",
      "msa & po": "crm_msa_po",
      "accounting": "hrm_accounting",
      "onboarding": "hrm_onboarding",
      "onboarding report": "hrm_onboarding_report",
      "deployment report": "deployment_report",
      "ats": "ats",
      "h1b management": "h1b",
      "h1b dashboard": "h1b",
      "user management": "user_management",
      "tenant management": "tenant_management",
      "invoices": "invoices",
      "timesheet approvals": "timesheet_approvals"
    };

    // Automatically detect and register all menus dynamically for the Permissions popup
    try {
      const dynamicCatalog = [];
      allConstructedItems.forEach(item => {
        if (!item || !item.label || item.label === "Dashboard") return;
        if (item.submenu && Array.isArray(item.submenu) && item.submenu.length > 0) {
          const groupItems = [];
          item.submenu.forEach(sub => {
            if (!sub || !sub.label) return;
            if (sub.submenu && Array.isArray(sub.submenu)) {
              sub.submenu.forEach(nested => {
                const subKey = KNOWN_KEY_MAP[nested.label.toLowerCase()] || toMenuKey(nested.label);
                groupItems.push({
                  key: subKey,
                  label: `${sub.label} - ${nested.label}`,
                  desc: `Access ${nested.label}`
                });
              });
            } else {
              const subKey = KNOWN_KEY_MAP[sub.label.toLowerCase()] || toMenuKey(sub.label);
              groupItems.push({
                key: subKey,
                label: sub.label,
                desc: `Access ${sub.label}`
              });
            }
          });
          if (groupItems.length > 0) {
            dynamicCatalog.push({
              category: item.label,
              items: groupItems
            });
          }
        } else {
          const itemKey = KNOWN_KEY_MAP[item.label.toLowerCase()] || toMenuKey(item.label);
          dynamicCatalog.push({
            category: "General Menus",
            items: [{
              key: itemKey,
              label: item.label,
              desc: `Access ${item.label}`
            }]
          });
        }
      });

      const catalogStr = JSON.stringify(dynamicCatalog);
      if (localStorage.getItem('erp_dynamic_sidebar_menus') !== catalogStr) {
        localStorage.setItem('erp_dynamic_sidebar_menus', catalogStr);
      }
    } catch (e) {}

    // Check if custom permissions are configured for current role
    if (!customPermsForRole) {
      // 100% backward-compatible fallback: returns exact current hardcoded list
      return allConstructedItems;
    }

    // Filter items based on active role permissions
    return allConstructedItems.map(item => {
      let itemKey = null;
      if (item.label === "Dashboard") itemKey = "home";
      else if (item.label === "My Timesheets" || item.label === "Timesheets") itemKey = "timesheets";
      else if (item.label === "Leave Manage") itemKey = "leave_manage";
      else if (item.label === "Profile") itemKey = "track_status";
      else if (item.label === "Recruitment") itemKey = "recruitment_dashboard";
      else if (item.label === "Job Submissions") itemKey = "submissions";
      else if (item.label === "Candidate Manage") itemKey = "candidate_manage";
      else if (item.label === "Bench Manage") itemKey = "bench_manage";
      else if (item.label === "CRM") itemKey = "crm";
      else if (item.label === "HRM") itemKey = "hrm";
      else if (item.label === "ATS") itemKey = "ats";
      else if (item.label === "H1B Management") itemKey = "h1b";
      else if (item.label === "User Management") itemKey = "user_management";
      else if (item.label === "Tenant Management") itemKey = "tenant_management";
      else if (item.label === "Invoices") itemKey = "invoices";
      else if (item.label === "Timesheet Approvals") itemKey = "timesheet_approvals";
      else itemKey = toMenuKey(item.label);

      // Super admin / admin always retains User Management & Tenant Management access
      if ((userRole === "admin" || userRole === "super_admin") && (itemKey === "user_management" || itemKey === "tenant_management")) {
        return item;
      }

      if (item.submenu) {
        const filteredSubmenu = item.submenu.filter(sub => {
          let subKey = null;
          if (sub.label === "Recruitment Dashboard") subKey = "recruitment_dashboard";
          else if (sub.label === "Dashboard" && itemKey === "submissions") subKey = "submissions";
          else if (sub.label === "Submission Report") subKey = "job_report";
          else if (sub.label === "Job Report") subKey = "job_count_report";
          else if (sub.label === "Client Report") subKey = "client_count";
          else if (sub.label === "Performance Report") subKey = "performance_report";
          else if (sub.label === "Sourcing") subKey = "candidate_sourcing";
          else if (sub.label === "Bench candidates") subKey = "candidate_bench";
          else if (sub.label === "Need To review") subKey = "candidate_review";
          else if (sub.label === "Bench Candidates" && itemKey === "bench_manage") subKey = "bench_candidates_list";
          else if (sub.label === "Dashboard" && itemKey === "bench_manage") subKey = "bench_dashboard";
          else if (sub.label === "Submission" && itemKey === "bench_manage") subKey = "bench_submissions";
          else if (sub.label === "Bench Report" && itemKey === "bench_manage") subKey = "bench_reports";
          else if (sub.label === "Bench Heat Report") subKey = "bench_heat_report";
          else if (sub.label === "Vendor & Client") subKey = "crm_companies";
          else if (sub.label === "MSA & PO") subKey = "crm_msa_po";
          else if (sub.label === "Accounting") subKey = "hrm_accounting";
          else if (sub.label === "Onboarding") subKey = "hrm_onboarding";
          else if (sub.label === "Deployment Report") subKey = "deployment_report";
          else if (sub.label === "H1B Dashboard") subKey = "h1b";
          else subKey = toMenuKey(sub.label);

          if (sub.submenu) {
            const allowedNested = sub.submenu.filter(nested => {
              if (nested.label === "Dashboard") return customPermsForRole.includes("hrm_onboarding");
              if (nested.label === "Onboarding Report") return customPermsForRole.includes("hrm_onboarding_report");
              const nestedKey = toMenuKey(nested.label);
              return customPermsForRole.includes(nestedKey);
            });
            return allowedNested.length > 0 && customPermsForRole.includes("hrm_onboarding");
          }

          if (!subKey) return true;
          return customPermsForRole.includes(subKey);
        }).map(sub => {
          if (sub.submenu) {
            return {
              ...sub,
              show: true,
              submenu: sub.submenu.map(nested => ({ ...nested, show: true }))
            };
          }
          return {
            ...sub,
            show: true
          };
        });

        const shouldShowGroup = filteredSubmenu.length > 0;

        // If employee or user with custom permissions has only 1 item in a submenu group, display that item directly as a top-level menu item
        if ((userRole === "employee" || (Array.isArray(activeUserPerms) && activeUserPerms.length > 0)) && filteredSubmenu.length === 1 && !filteredSubmenu[0].submenu) {
          const singleSub = filteredSubmenu[0];
          let directLabel = singleSub.label;
          if (singleSub.label === "Dashboard" && item.label === "Job Submissions") {
            directLabel = "Submissions Dashboard";
          }
          return {
            path: singleSub.path || (singleSub.label === "Accounting" ? "/companies" : undefined),
            label: directLabel,
            icon: React.isValidElement(singleSub.icon)
              ? React.cloneElement(singleSub.icon, { size: 20 })
              : (item.icon || singleSub.icon),
            onClick: singleSub.onClick,
            show: true
          };
        }

        return {
          ...item,
          show: shouldShowGroup,
          submenu: filteredSubmenu
        };
      }

      const isAllowed = !itemKey || customPermsForRole.includes(itemKey);
      return {
        ...item,
        // When custom permissions are configured, the permission list is the source of truth.
        // Do NOT gate with item.show (hardcoded role check) — that would block permission-granted menus.
        show: isAllowed
      };
    });
  };

  const storedCompany = (localStorage.getItem('company_id') || localStorage.getItem('saas_company_id') || '').toLowerCase().trim();
  const effectiveCompanyId = (companyId || storedCompany || 'prophecy').toLowerCase().trim();
  const isCompanyProphecy = effectiveCompanyId === 'prophecy';

  const effectiveAllowedModules = (allowedModules && allowedModules.length > 0)
    ? allowedModules
    : (() => {
        try {
          const raw = localStorage.getItem(`saas_config_${effectiveCompanyId}`);
          if (raw) {
            const p = JSON.parse(raw);
            if (Array.isArray(p.allowedModules)) return p.allowedModules;
          }
        } catch (e) {}
        return isCompanyProphecy 
          ? ['Recruitment', 'ATS', 'Invoice', 'Timesheet', 'H1B', 'CRM'] 
          : ['Recruitment'];
      })();

  const rawMenuItems = getMenuItems();
  const menuItems = rawMenuItems.filter(item => {
    // 1. Prophecy ERP always has 100% full access to all modules and features
    if (isCompanyProphecy) return true;

    const label = (item.label || '').toLowerCase();

    // Helper: Checks if a specific module is active for this tenant in dbo.TenantModules
    const isModuleAllowed = (name) => {
      const cleanTarget = name.toLowerCase().replace(/[^a-z0-9]/g, '');
      return effectiveAllowedModules && effectiveAllowedModules.some(m => m.toLowerCase().replace(/[^a-z0-9]/g, '') === cleanTarget);
    };

    // Recruitment module: ONLY the core Recruitment module
    if (label === 'recruitment' || label.includes('recruitment dashboard')) {
      return isModuleAllowed('Recruitment');
    }

    // Job Submissions: strictly requires 'Job Submissions' or 'Submissions' in dbo.TenantModules
    if (label === 'job submissions' || label.includes('submission')) {
      return isModuleAllowed('Job Submissions') || isModuleAllowed('Submissions');
    }

    // Candidate Manage: strictly requires 'Candidate Manage' or 'Candidates' in dbo.TenantModules
    if (label === 'candidate manage') {
      return isModuleAllowed('Candidate Manage') || isModuleAllowed('Candidates');
    }

    // ATS module
    if (label === 'ats' || label.includes('applicant')) {
      return isModuleAllowed('ATS');
    }

    // CRM module
    if (label === 'crm' || label.includes('vendor & client') || label.includes('msa')) {
      return isModuleAllowed('CRM');
    }

    // Bench Manage: Prophecy only (or if explicitly added to TenantModules)
    if (label.includes('bench')) {
      return isModuleAllowed('Bench') || isModuleAllowed('Bench Manage');
    }

    // HRM / Accounts: Prophecy only (or if explicitly added to TenantModules)
    if (label === 'hrm' || label.includes('accounting') || label.includes('onboarding') || label.includes('deployment')) {
      return isModuleAllowed('HRM') || isModuleAllowed('Accounting');
    }

    // User Management: Prophecy only (or if explicitly added to TenantModules)
    if (label.includes('user management')) {
      return isModuleAllowed('User Management');
    }

    // Invoices module
    if (label.includes('invoice')) {
      return isModuleAllowed('Invoice') || isModuleAllowed('Invoices');
    }

    // Timesheets / Leave module
    if (label.includes('timesheet') || label.includes('time sheet') || label.includes('leave')) {
      return isModuleAllowed('Timesheet') || isModuleAllowed('Timesheets') || isModuleAllowed('Leave');
    }

    // H1B module
    if (label.includes('h1b') || label.includes('visa')) {
      return isModuleAllowed('H1B');
    }

    // Tenant Management: Prophecy ONLY (Never shown for client companies)
    if (label.includes('tenant')) {
      return isCompanyProphecy;
    }

    // Settings & Log Out: always available for all tenants
    if (label.includes('settings') || label.includes('logout')) return true;

    return false;
  });

  return (
    <>
      {/* Mobile Toggle Button - Outside Sidebar */}
      {isMobile && (
        <button
          className={`sidebar-toggle ${isSidebarVisible ? 'open' : ''}`}
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
        >
          {isSidebarVisible ? <LuChevronLeft /> : <LuChevronRight />}
        </button>
      )}

      <div className={`sidebar-overlay ${isMobile && isSidebarVisible ? 'visible' : ''}`} onClick={() => setIsSidebarVisible(false)}></div>

      <div className="Mainsidebar-container">
        <div
          ref={sidebarRef}
          className={`sidebar ${isExpanded ? "expanded" : "collapsed"} ${isSidebarVisible ? "visible" : "hidden"}`}
          onMouseEnter={() => !isMobile && !isPinned && setIsHovered(true)}
          onMouseLeave={() => !isMobile && !isPinned && setIsHovered(false)}
        >
          {/* Sidebar Header */}
          <div className="sidebar-header">
            <div className="logo-container">
              {logoUrl && !sidebarLogoFailed ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
                  <img 
                    src={resolveLogoUrl(logoUrl)} 
                    alt="Logo" 
                    className="initial-logo" 
                    style={{ maxHeight: '34px', maxWidth: '34px', objectFit: 'contain', borderRadius: '4px' }} 
                    onError={() => setSidebarLogoFailed(true)}
                  />
                  {isExpanded && (
                    <span 
                      className="logo" 
                      style={{ 
                        color: '#ffffff', 
                        fontWeight: 800, 
                        fontSize: '18px', 
                        letterSpacing: '1.2px', 
                        whiteSpace: 'nowrap',
                        lineHeight: '34px',
                        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                      }}
                    >
                      {(companyName || (isCompanyProphecy ? 'Prophecy ERP' : (effectiveCompanyId === 'disen' ? 'Disen Systems' : (effectiveCompanyId === 'cognifyar' ? 'Cognifyar Technologies' : effectiveCompanyId)))).toUpperCase()}
                    </span>
                  )}
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
                  <div style={{
                    minWidth: '32px',
                    height: '32px',
                    borderRadius: '7px',
                    backgroundColor: 'rgba(255, 255, 255, 0.16)',
                    border: '1px solid rgba(255, 255, 255, 0.28)',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 800,
                    fontSize: '16px'
                  }}>
                    {((companyName || effectiveCompanyId || 'P').charAt(0)).toUpperCase()}
                  </div>
                  {isExpanded && (
                    <span 
                      className="logo" 
                      style={{ 
                        color: '#ffffff', 
                        fontWeight: 800, 
                        fontSize: '18px', 
                        letterSpacing: '1.2px', 
                        whiteSpace: 'nowrap',
                        lineHeight: '32px',
                        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
                      }}
                    >
                      {(companyName || (isCompanyProphecy ? 'Prophecy ERP' : effectiveCompanyId)).toUpperCase()}
                    </span>
                  )}
                </div>
              )}
            </div>

            {/* Pin Button - Only show on desktop */}
            {isExpanded && !isMobile && (
              <button className="pin-button" onClick={handleTogglePin} aria-label={isPinned ? "Unpin sidebar" : "Pin sidebar"}>
                <FaThumbtack className={`pin-icon ${isPinned ? "pinned" : ""}`} />
              </button>
            )}

            {/* Close Button - Only show on mobile */}
            {isExpanded && isMobile && (
              <button className="close-button" onClick={() => setIsSidebarVisible(false)} aria-label="Close sidebar">
                <LuChevronLeft />
              </button>
            )}
          </div>

          {/* Sidebar Menu */}
          <nav>
            <ul className="menu">
              {menuItems.map((item, index) => {
                if (!item.show) return null;

                if (item.submenu) {
                  return (
                    <React.Fragment key={index}>
                      <li
                        className={`menu-item ${openSubmenu === item.label ? "open" : ""} ${item.submenu.some(subItem => subItem.path ? isActive(subItem.path) : (subItem.submenu && subItem.submenu.some(nested => isActive(nested.path)))) ? "active" : ""}`}
                        onClick={() => toggleSubmenu(item.label)}
                        title={!isExpanded ? item.label : undefined}
                        data-tooltip={!isExpanded ? item.label : undefined}
                      >
                        {item.icon}
                        {isExpanded && <span className="menu-text">{item.label}</span>}
                        {isExpanded && item.submenu && (
                          <span className="submenu-icon">
                            {openSubmenu === item.label ? <FaAngleUp /> : <FaAngleDown />}
                          </span>
                        )}
                        {item.submenu.some(subItem => subItem.path ? isActive(subItem.path) : (subItem.submenu && subItem.submenu.some(nested => isActive(nested.path)))) && <span className="active-indicator"></span>}
                      </li>

                      {isExpanded && openSubmenu === item.label && (
                        <ul className="submenu">
                          {item.submenu.filter(subItem => subItem.show !== false).map((subItem, subIndex) => {
                            if (subItem.submenu) {
                              const isNestedActive = subItem.submenu.some(nested => isActive(nested.path));
                              const isNestedOpen = openNestedSubmenu === subItem.label;
                              return (
                                <React.Fragment key={subIndex}>
                                  <li
                                    className={`submenu-item ${isNestedOpen ? "open" : ""} ${isNestedActive ? "active" : ""}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setOpenNestedSubmenu(prev => prev === subItem.label ? null : subItem.label);
                                    }}
                                    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
                                  >
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                      <span className="submenu-icon">{subItem.icon}</span>
                                      <span className="submenu-text">{subItem.label}</span>
                                    </div>
                                    <span style={{ fontSize: "11px", marginLeft: "auto", marginRight: "4px", opacity: 0.85 }}>
                                      {isNestedOpen ? <FaAngleUp /> : <FaAngleDown />}
                                    </span>
                                    {isNestedActive && <span className="active-indicator"></span>}
                                  </li>

                                  {isNestedOpen && (
                                    <ul className="nested-submenu" style={{ listStyle: "none", padding: "0 0 0 16px", margin: "2px 0" }}>
                                      {subItem.submenu.filter(nested => nested.show !== false).map((nested, nIndex) => (
                                        <li
                                          key={nIndex}
                                          className={`submenu-item ${isActive(nested.path) ? "active" : ""}`}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            navigate(nested.path);
                                          }}
                                          style={{ padding: "8px 12px", fontSize: "13px", display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
                                        >
                                          <span className="submenu-icon" style={{ fontSize: "14px" }}>{nested.icon}</span>
                                          <span className="submenu-text">{nested.label}</span>
                                          {isActive(nested.path) && <span className="active-indicator"></span>}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </React.Fragment>
                              );
                            }

                            return (
                              <li
                                key={subIndex}
                                className={`submenu-item ${isActive(subItem.path) ? "active" : ""}`}
                                onClick={subItem.onClick ? subItem.onClick : () => navigate(subItem.path)}
                              >
                                <span className="submenu-icon">{subItem.icon}</span>
                                <span className="submenu-text">{subItem.label}</span>
                                {isActive(subItem.path) && <span className="active-indicator"></span>}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </React.Fragment>
                  );
                } else {
                  return (
                    <li
                      key={index}
                      className={`menu-item ${item.onClick && isRecruitmentActive() ? "active" : isActive(item.path) ? "active" : ""}`}
                      onClick={item.onClick ? item.onClick : () => navigate(item.path)}
                      title={!isExpanded ? item.label : undefined}
                      data-tooltip={!isExpanded ? item.label : undefined}
                    >
                      {item.icon}
                      {isExpanded && <span className="menu-text">{item.label}</span>}
                      {(item.onClick && isRecruitmentActive()) || (item.path === "/ats" && isATSActive()) || (item.path === "/jobs" && isJobsActive()) || isActive(item.path) ? <span className="active-indicator"></span> : null}
                    </li>
                  );
                }
              })}

              {/* Bench Sales Submenu - Only show if user is not employee and not external user */}
              {shouldShowBenchSales && (
                <li
                  className={`menu-item ${openBenchSalesSubmenu ? "open" : ""} ${location.pathname.includes("/bench-") || location.pathname === "/bench-sales" ? "active" : ""}`}
                  onClick={toggleBenchSalesSubmenu}
                  title={!isExpanded ? "Bench Sales" : undefined}
                  data-tooltip={!isExpanded ? "Bench Sales" : undefined}
                >
                  <LuChartBar size={20} />
                  {isExpanded && <span className="menu-text">Bench Sales</span>}
                  {isExpanded && (
                    <span className="submenu-icon">
                      {openBenchSalesSubmenu ? <FaAngleUp /> : <FaAngleDown />}
                    </span>
                  )}
                  {(location.pathname.includes("/bench-") || location.pathname === "/bench-sales") && <span className="active-indicator"></span>}
                </li>
              )}
              
              {/* Bench Sales Submenu Items - Only show if user is not employee and not external user */}
              {shouldShowBenchSales && isExpanded && openBenchSalesSubmenu && (
                <ul className="submenu">
                  <li
                    className={`submenu-item ${isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter") ? "active" : ""}`}
                    onClick={handleBenchSalesClick}
                  >
                    <span className="submenu-icon"><LuLayoutDashboard size={16} /></span>
                    <span className="submenu-text">Bench Sales Dashboard</span>
                    {(isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter")) && <span className="active-indicator"></span>}
                  </li>
                  {benchSalesMenu.map((item, index) => (
                    <li
                      key={index}
                      className={`submenu-item ${isActive(item.path) ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        navigate(item.path);
                      }}
                    >
                      <span className="submenu-icon">{item.icon}</span>
                      <span className="submenu-text">{item.label}</span>
                      {isActive(item.path) && <span className="active-indicator"></span>}
                    </li>
                  ))}
                </ul>
              )}
            </ul>
          </nav>

          {/* Settings & Logout - Only show if user is logged in */}
          {userRole && (
            <div className="settings-section">
              <ul>
                {!isExternalUser && (
                  <li className={isActive("/recruitment/social-settings") ? "active" : ""} onClick={() => navigate("/recruitment/social-settings")} title={!isExpanded ? "Settings" : undefined} data-tooltip={!isExpanded ? "Settings" : undefined}>
                    <LuSettings size={20} />
                    {isExpanded && <span className="menu-text">Settings</span>}
                    {isActive("/recruitment/social-settings") && <span className="active-indicator"></span>}
                  </li>
                )}
                <li onClick={handleLogout} title={!isExpanded ? "Log Out" : undefined} data-tooltip={!isExpanded ? "Log Out" : undefined}>
                  <LuLogOut size={20} />
                  {isExpanded && <span className="menu-text">Log Out</span>}
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;






// import React, { useEffect, useState, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import BASE_URL from "../../url";

// import {
//   LuLayoutDashboard,
//   LuBriefcase,
//   LuSettings,
//   LuLogOut,
//   LuChevronLeft,
//   LuChevronRight,
//   LuUserCheck,
//   LuUsers,
//   LuFileText,
//   LuChartBar,
//   LuUserPlus,
//   LuSend,
//   LuTarget,
//   LuBarChart,
//   LuStar,
//   LuClock,
//   LuClipboardList,
//   LuFileStack,
//   LuCircleCheck,
//   LuCalendar
// } from "react-icons/lu";


// import { FaAngleDown, FaAngleUp, FaThumbtack } from "react-icons/fa";
// import "../styles/Sidebar.css";
// import prophecyLogo2 from "../Assets/images/prophecy-logo2.png";
// import prophecyLogo from "../Assets/images/prophecy-logo.png";

// const Sidebar = () => {
//   const [isPinned, setIsPinned] = useState(localStorage.getItem("sidebarPinned") === "true");
//   const [isHovered, setIsHovered] = useState(false);
//   const [openSubmenu, setOpenSubmenu] = useState(null);
//   const [openBenchSalesSubmenu, setOpenBenchSalesSubmenu] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [isSidebarVisible, setIsSidebarVisible] = useState(true);
//   const sidebarRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Get user role from localStorage
//   const userRole = localStorage.getItem("role");
//   const isExpanded = isPinned || isHovered || isMobile;

//   // Check if user is external user
//   const isExternalUser = userRole === 'External user' || userRole === 'external_user' || userRole === 'external-user';

//   // âœ… CHECK IF USER IS ADMIN FOR H1B ACCESS (ADMIN ONLY)
//   const isAdmin = userRole === 'admin' || userRole === 'super_admin';

//   // âœ… REDIRECT EXTERNAL USERS TO CANDIDATE FORM
//   useEffect(() => {
//     if (isExternalUser && location.pathname !== "/ats") {
//       navigate("/ats?candidateForm=true", { replace: true });
//     }
//   }, [isExternalUser, navigate, location.pathname]);

//   // Handle screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth <= 768;
//       setIsMobile(mobile);
//       if (mobile && isPinned) {
//         setIsSidebarVisible(false);
//       } else {
//         setIsSidebarVisible(true);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [isPinned]);

//   // Save pinned state to localStorage
//   useEffect(() => {
//     localStorage.setItem("sidebarPinned", isPinned);
//   }, [isPinned]);

//   // Handle clicks outside sidebar to close it on mobile
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobile && !isPinned && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setIsSidebarVisible(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isMobile, isPinned]);

//   // Close sidebar when route changes on mobile
//   useEffect(() => {
//     if (isMobile && !isPinned) {
//       setIsSidebarVisible(false);
//     }
//   }, [location, isMobile, isPinned]);

//   // UPDATED LOGOUT FUNCTION WITH TRACKING
//   const handleLogout = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const sessionId = localStorage.getItem('currentSessionId');
      
//       console.log('ðŸšª Manual logout initiated');
      
//       // Track logout if we have a session ID
//       if (sessionId && token) {
//         try {
//           const response = await fetch(`${BASE_URL}/api/auth/track-logout`, {
//             method: "POST",
//             headers: { 
//               "Content-Type": "application/json",
//               "Authorization": `Bearer ${token}`
//             },
//             credentials: 'include',
//             body: JSON.stringify({ trackingId: parseInt(sessionId) })
//           });
          
//           if (response.ok) {
//             console.log('âœ… Logout tracked successfully');
//           } else {
//             console.log('âš ï¸ Logout tracking failed, but continuing...');
//           }
//         } catch (trackError) {
//           console.error("Error tracking logout:", trackError);
//         }
//       }
      
//       // Clear all stored data
//       localStorage.removeItem('token');
//       localStorage.removeItem('username');
//       localStorage.removeItem('role');
//       localStorage.removeItem('id');
//       localStorage.removeItem('user');
//       localStorage.removeItem('firstName');
//       localStorage.removeItem('currentSessionId');
//       localStorage.removeItem('sidebarPinned');
      
//       console.log('ðŸ§¹ Local storage cleared');
      
//       // Navigate to login
//       navigate('/');
      
//     } catch (error) {
//       console.error("Error during logout:", error);
//       localStorage.clear();
//       navigate('/');
//     }
//   };

//   const toggleSidebar = () => {
//     setIsSidebarVisible(!isSidebarVisible);
//   };

//   const toggleSubmenu = (menu) => {
//     setOpenSubmenu(openSubmenu === menu ? null : menu);
//   };

//   const toggleBenchSalesSubmenu = () => {
//     setOpenBenchSalesSubmenu(!openBenchSalesSubmenu);
//   };

//   const isActive = (path) => {
//     if (path.includes('?')) {
//       // Special handling for resume-dashboard to ignore other query params like 't' or 'refresh'
//       if (path.startsWith('/resume-dashboard')) {
//         const currentParams = new URLSearchParams(location.search);
//         const targetParams = new URLSearchParams(path.split('?')[1]);
//         return location.pathname === '/resume-dashboard' && currentParams.get('view') === targetParams.get('view');
//       }
//       return (location.pathname + location.search) === path;
//     }
//     return location.pathname === path;
//   };

//   // Check if current path is recruitment related
//   const isRecruitmentActive = () => {
//     return location.pathname === "/recruitment-dashboard" || 
//            location.pathname === "/recruiter-view" || 
//            location.pathname === "/teamlead-dashboard" ||
//            location.pathname === "/admin-dashboard" ||
//            location.pathname === "/vendor-management";
//   };

//   // Check if current path is ATS related
//   const isATSActive = () => {
//     return location.pathname === "/ats";
//   };

//   // âœ… Check if current path is H1B related (Dashboard or Details only)
//   const isH1BActive = () => {
//     return location.pathname === "/h1b/dashboard" || location.pathname.startsWith("/h1b/submissions/");
//   };

//   // Check if current path is Jobs related
//   const isJobsActive = () => {
//     return location.pathname === "/careers" ;
//   };

//   // Direct navigation to recruitment dashboard based on user role
//   const handleRecruitmentClick = () => {
//     if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
//       navigate("/recruitment-dashboard");
//     } else if (userRole === "user" || userRole === "recruiter") {
//       navigate("/recruiter-view");
//     } else if (userRole === "teamlead" || userRole === "team_lead") {
//       navigate("/teamlead-dashboard");
//     } else {
//       navigate("/recruitment-dashboard");
//     }
//   };

//   // Direct navigation to bench sales dashboard based on user role
//   const handleBenchSalesClick = () => {
//     if (userRole === "manager" || userRole === "admin" || userRole === "super_admin") {
//       navigate("/bench-sales-dashboard");
//     } else if (userRole === "user") {
//       navigate("/bench-sales-recruiter");
//     } else if (userRole === "teamlead") {
//       navigate("/bench-sales-dashboard");
//     }
//   };

//   const benchSalesMenu = [
//     { path: "/bench-candidates", label: "Candidate Management", icon: <LuUsers size={16} /> },
//     { path: "/bench-requirements", label: "Requirements", icon: <LuFileText size={16} /> },
//     { path: "/bench-submissions", label: "Submissions", icon: <LuSend size={16} /> },
//     { path: "/bench-vendors", label: "Vendors", icon: <LuUsers size={16} /> },
//     { path: "/bench-marketing", label: "Marketing", icon: <LuTarget size={16} /> },
//     { path: "/bench-hotlist", label: "Hotlist", icon: <LuStar size={16} /> },
//   ];

//   // âœ… H1B SUBMENU - ADMIN ONLY (Dashboard and View Details)
//   const h1bMenu = [
//     { path: "/h1b/dashboard", label: "H1B Dashboard", icon: <LuLayoutDashboard size={16} /> },
//     // { path: "/h1b/submissions", label: "View Details", icon: <LuFileStack size={16} /> },
//   ];

//   // Check if ATS should be shown
//   const shouldShowATS = userRole === "admin" || userRole === "super_admin" || userRole === "manager" || userRole === "User" || userRole === "teamlead" || userRole === "team_lead";

//   // Check if Bench Sales should be shown
//   const shouldShowBenchSales = userRole && userRole !== "employee" && !isExternalUser;

//   // âœ… CHECK IF H1B SHOULD BE SHOWN - ADMIN ONLY
//   const shouldShowH1B = isAdmin;

//   // Check if Jobs should be shown - ONLY for external users
//   const shouldShowJobs = isExternalUser;

//   const shouldShowAccounts = userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager";
//   const shouldShowTimesheetApprovals = userRole === "admin" || userRole === "super_admin" || userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || localStorage.getItem('isSupervisor') === 'true';



//   // Menu items based on user role
//   const getMenuItems = () => {
//     // If user is external user, show only Candidate Form (no menu needed, will redirect)
//     if (isExternalUser) {
//       return [
//         { 
//           path: "/ats?candidateForm=true", 
//           label: "Application Form", 
//           icon: <LuBriefcase size={20} />,
//           show: true
//         }
//       ];
//     }

//     // If user is employee, show only Dashboard, Accounts, and Timesheets
//     if (userRole === "employee") {
//       return [
//         { 
//           path: "/home", 
//           label: "Dashboard", 
//           icon: <LuLayoutDashboard size={20} />,
//           show: true
//         },
//         {
//           label: "Accounts",
//           icon: <LuFileText size={20} />,
//           path: "/accounts",
//           show: true
//         },
//         {
//           label: "Timesheets",
//           icon: <LuClock size={20} />,
//           path: "/timesheets",
//           show: true
//         },
//         {
//           label: "Leave Manage",
//           icon: <LuCalendar size={20} />,
//           path: "/leave-manage",
//           show: true
//         },
//         {
//           label: "Timesheet Approvals",
//           icon: <LuCircleCheck size={20} />,
//           path: "/timesheet-approvals",
//           show: localStorage.getItem('isSupervisor') === 'true'
//         }

//       ];
//     }


//     // For all other roles, show the full menu
//     const baseItems = [
//       { 
//         path: "/home", 
//         label: "Dashboard", 
//         icon: <LuLayoutDashboard size={20} />,
//         show: true
//       },
//       {
//         path: "/timesheets?mode=internal",
//         label: "My Timesheets",
//         icon: <LuClock size={20} />,
//         show: userRole === "manager" || userRole === "teamlead" || userRole === "team_lead" || userRole === "user" || userRole === "admin"
//       },
//       {
//         path: "/leave-manage",
//         label: "Leave Manage",
//         icon: <LuCalendar size={20} />,
//         show: true
//       }
//     ];

//     // Recruitment submenu
//     const recruitmentSubmenu = [
//       { 
//         path: "/recruitment-dashboard", 
//         label: "Recruitment Dashboard", 
//         icon: <LuLayoutDashboard size={16} />,
//         onClick: handleRecruitmentClick,
//         show: true
//       },
//       { 
//         path: "/vendor-management", 
//         label: "Vendor Management", 
//         icon: <LuUsers size={16} />,
//         onClick: () => navigate("/vendor-management"),
//         show: true
//       }
//     ];

//     const recruitmentItem = {
//       label: "Recruitment",
//       icon: <LuBriefcase size={20} />,
//       submenu: recruitmentSubmenu,
//       show: true
//     };

//     const candidateManagementSubmenu = [
//       { 
//         path: "/resume-dashboard?view=sourcing", 
//         label: "Sourcing", 
//         icon: <LuUserCheck size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=sourcing&t=${Date.now()}`),
//         show: true
//       },
//       { 
//         path: "/resume-dashboard?view=bench", 
//         label: "Bench candidates", 
//         icon: <LuUsers size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=bench&t=${Date.now()}`),
//         show: true
//       },
//       { 
//         path: "/resume-dashboard?view=review", 
//         label: "Need To review", 
//         icon: <LuFileStack size={16} />,
//         onClick: () => navigate(`/resume-dashboard?view=review&t=${Date.now()}`),
//         show: true
//       }
//     ];

//     const resumeSubmissionItem = {
//       label: "Candidate Manage",
//       icon: <LuUsers size={20} />,
//       submenu: candidateManagementSubmenu,
//       show: true
//     };

//     const submissionsItem = {
//       path: "/submissions", 
//       label: "Job Submissions", 
//       icon: <LuSend size={20} />,
//       show: true
//     };

//     const atsItem = {
//       path: "/ats",
//       label: "ATS",
//       icon: <LuClipboardList size={20} />,
//       show: shouldShowATS
//     };

//     // âœ… H1B ITEM - ADMIN ONLY (with submenu)
//     const h1bItem = {
//       label: "H1B Management",
//       icon: <LuFileStack size={20} />,
//       submenu: h1bMenu,
//       show: shouldShowH1B
//     };

//     const msaItem = {
//       path: "/msa",
//       label: "MSA",
//       icon: <LuFileText size={20} />,
//       show: userRole === "admin" || userRole === "super_admin" || userRole === "account_manager" || userRole === "account-manager"
//     };

//     const adminItems = [
//       {
//         label: "User Management",
//         icon: <LuUsers size={20} />,
//         path: "/user-management",
//         show: userRole === "admin" || userRole === "super_admin"
//       },
//       {
//         label: "Accounting",
//         icon: <LuFileText size={20} />,
//         path: "/companies",
//         show: shouldShowAccounts
//       },
//       {
//         label: "Onboarding",
//         icon: <LuUserPlus size={20} />,
//         path: "/onboarding",
//         show: userRole === "admin" || userRole === "super_admin"
//       },
//       {
//         label: "Timesheet Approvals",
//         icon: <LuClock size={20} />,
//         path: "/timesheet-approvals",
//         show: shouldShowTimesheetApprovals
//       }
//     ];

//     return [
//       ...baseItems,
//       recruitmentItem,
//       resumeSubmissionItem,
//       submissionsItem,
//       atsItem,
//       h1bItem,  // âœ… ADDED H1B ITEM WITH SUBMENU
//       msaItem,  // âœ… ADDED MSA ITEM
//       ...adminItems.filter(item => item.show)
//     ];
//   };

//   const menuItems = getMenuItems();

//   return (
//     <>
//       {/* Mobile Toggle Button - Outside Sidebar */}
//       {isMobile && (
//         <button
//           className={`sidebar-toggle ${isSidebarVisible ? 'open' : ''}`}
//           onClick={toggleSidebar}
//           aria-label="Toggle sidebar"
//         >
//           {isSidebarVisible ? <LuChevronLeft /> : <LuChevronRight />}
//         </button>
//       )}

//       <div className={`sidebar-overlay ${isMobile && isSidebarVisible ? 'visible' : ''}`} onClick={() => setIsSidebarVisible(false)}></div>

//       <div className="Mainsidebar-container">
//         <div
//           ref={sidebarRef}
//           className={`sidebar ${isExpanded ? "expanded" : "collapsed"} ${isSidebarVisible ? "visible" : "hidden"}`}
//           onMouseEnter={() => !isMobile && !isPinned && setIsHovered(true)}
//           onMouseLeave={() => !isMobile && !isPinned && setIsHovered(false)}
//         >
//           {/* Sidebar Header */}
//           <div className="sidebar-header">
//             <div className="logo-container">
//               <img src={prophecyLogo2} alt="Logo" className="initial-logo" />
//               {isExpanded && <img src={prophecyLogo} alt="Logo" className="logo" />}
//             </div>

//             {/* Pin Button - Only show on desktop */}
//             {isExpanded && !isMobile && (
//               <button className="pin-button" onClick={() => setIsPinned(!isPinned)} aria-label={isPinned ? "Unpin sidebar" : "Pin sidebar"}>
//                 <FaThumbtack className={`pin-icon ${isPinned ? "pinned" : ""}`} />
//               </button>
//             )}

//             {/* Close Button - Only show on mobile */}
//             {isExpanded && isMobile && (
//               <button className="close-button" onClick={() => setIsSidebarVisible(false)} aria-label="Close sidebar">
//                 <LuChevronLeft />
//               </button>
//             )}
//           </div>

//           {/* Sidebar Menu */}
//           <nav>
//             <ul className="menu">
//               {menuItems.map((item, index) => {
//                 if (!item.show) return null;

//                 if (item.submenu) {
//                   return (
//                     <React.Fragment key={index}>
//                       <li
//                         className={`menu-item ${openSubmenu === item.label ? "open" : ""} ${item.submenu.some(subItem => isActive(subItem.path)) ? "active" : ""}`}
//                         onClick={() => toggleSubmenu(item.label)}
//                       >
//                         {item.icon}
//                         {isExpanded && <span className="menu-text">{item.label}</span>}
//                         {isExpanded && item.submenu && (
//                           <span className="submenu-icon">
//                             {openSubmenu === item.label ? <FaAngleUp /> : <FaAngleDown />}
//                           </span>
//                         )}
//                         {item.submenu.some(subItem => isActive(subItem.path)) && <span className="active-indicator"></span>}
//                       </li>

//                       {isExpanded && openSubmenu === item.label && (
//                         <ul className="submenu">
//                           {item.submenu.filter(subItem => subItem.show !== false).map((subItem, subIndex) => (
//                             <li
//                               key={subIndex}
//                               className={`submenu-item ${isActive(subItem.path) ? "active" : ""}`}
//                               onClick={subItem.onClick ? subItem.onClick : () => navigate(subItem.path)}
//                             >
//                               <span className="submenu-icon">{subItem.icon}</span>
//                               <span className="submenu-text">{subItem.label}</span>
//                               {isActive(subItem.path) && <span className="active-indicator"></span>}
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </React.Fragment>
//                   );
//                 } else {
//                   return (
//                     <li
//                       key={index}
//                       className={`menu-item ${item.onClick && isRecruitmentActive() ? "active" : isActive(item.path) ? "active" : ""}`}
//                       onClick={item.onClick ? item.onClick : () => navigate(item.path)}
//                     >
//                       {item.icon}
//                       {isExpanded && <span className="menu-text">{item.label}</span>}
//                       {(item.onClick && isRecruitmentActive()) || (item.path === "/ats" && isATSActive()) || (item.path === "/jobs" && isJobsActive()) || isActive(item.path) ? <span className="active-indicator"></span> : null}
//                     </li>
//                   );
//                 }
//               })}

//               {/* Bench Sales Submenu - Only show if user is not employee and not external user */}
//               {shouldShowBenchSales && (
//                 <li
//                   className={`menu-item ${openBenchSalesSubmenu ? "open" : ""} ${location.pathname.includes("/bench-") || location.pathname === "/bench-sales" ? "active" : ""}`}
//                   onClick={toggleBenchSalesSubmenu}
//                 >
//                   <LuChartBar size={20} />
//                   {isExpanded && <span className="menu-text">Bench Sales</span>}
//                   {isExpanded && (
//                     <span className="submenu-icon">
//                       {openBenchSalesSubmenu ? <FaAngleUp /> : <FaAngleDown />}
//                     </span>
//                   )}
//                   {(location.pathname.includes("/bench-") || location.pathname === "/bench-sales") && <span className="active-indicator"></span>}
//                 </li>
//               )}
              
//               {/* Bench Sales Submenu Items - Only show if user is not employee and not external user */}
//               {shouldShowBenchSales && isExpanded && openBenchSalesSubmenu && (
//                 <ul className="submenu">
//                   <li
//                     className={`submenu-item ${isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter") ? "active" : ""}`}
//                     onClick={handleBenchSalesClick}
//                   >
//                     <span className="submenu-icon"><LuLayoutDashboard size={16} /></span>
//                     <span className="submenu-text">Bench Sales Dashboard</span>
//                     {(isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter")) && <span className="active-indicator"></span>}
//                   </li>
//                   {benchSalesMenu.map((item, index) => (
//                     <li
//                       key={index}
//                       className={`submenu-item ${isActive(item.path) ? "active" : ""}`}
//                       onClick={(e) => {
//                         e.preventDefault();
//                         e.stopPropagation();
//                         navigate(item.path);
//                       }}
//                     >
//                       <span className="submenu-icon">{item.icon}</span>
//                       <span className="submenu-text">{item.label}</span>
//                       {isActive(item.path) && <span className="active-indicator"></span>}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </ul>
//           </nav>

//           {/* Settings & Logout - Only show if user is logged in */}
//           {userRole && (
//             <div className="settings-section">
//               <ul>
//                 {!isExternalUser && (
//                   <li className={isActive("/settings") ? "active" : ""} onClick={() => navigate("/settings")}>
//                     <LuSettings size={20} />
//                     {isExpanded && <span className="menu-text">Settings</span>}
//                     {isActive("/settings") && <span className="active-indicator"></span>}
//                   </li>
//                 )}
//                 <li onClick={handleLogout}>
//                   <LuLogOut size={20} />
//                   {isExpanded && <span className="menu-text">Log Out</span>}
//                 </li>
//               </ul>
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;



// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import BASE_URL from "../../url";

// import {
//   LuLayoutDashboard,
//   LuBriefcase,
//   LuSettings,
//   LuLogOut,
//   LuChevronLeft,
//   LuChevronRight,
//   LuUserCheck,
//   LuUsers,
//   LuFileText,
//   LuChartBar,
//   LuUserPlus,
//   LuSend,
//   LuTarget,
//   LuStar,
//   LuClock,
//   LuClipboardList,
//   LuReceipt,
//   LuBuilding,
//   LuFilePen,
// } from "react-icons/lu";
// import { FaAngleDown, FaAngleUp, FaThumbtack, FaLock } from "react-icons/fa";
// import "../styles/Sidebar.css";
// import prophecyLogo2 from "../Assets/images/prophecy-logo2.png";
// import prophecyLogo from "../Assets/images/prophecy-logo.png";

// const Sidebar = () => {
//   const [isPinned, setIsPinned] = useState(localStorage.getItem("sidebarPinned") === "true");
//   const [isHovered, setIsHovered] = useState(false);
//   const [openSubmenu, setOpenSubmenu] = useState(null);
//   const [openBenchSalesSubmenu, setOpenBenchSalesSubmenu] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [isSidebarVisible, setIsSidebarVisible] = useState(true);
//   const sidebarRef = useRef(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const userRole = localStorage.getItem("role");
//   const isExpanded = isPinned || isHovered || isMobile;

//   // Check if user is external user
//   const isExternalUser = userRole === 'External user' || userRole === 'external_user' || userRole === 'external-user';
  
//   // Check if user is candidate
//   const isCandidate = userRole === 'candidate';
  
//   // Check if user is employer
//   const isEmployer = userRole === 'employer';

//   // Redirect external users to candidate form
//   useEffect(() => {
//     if (isExternalUser && location.pathname !== "/ats") {
//       navigate("/ats?candidateForm=true", { replace: true });
//     }
//   }, [isExternalUser, navigate, location.pathname]);

//   // âœ… Redirect employers away from /home to their dashboard
//   useEffect(() => {
//     if (isEmployer && location.pathname === "/home") {
//       navigate("/employer-dashboard", { replace: true });
//     }
//   }, [isEmployer, navigate, location.pathname]);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth <= 768;
//       setIsMobile(mobile);
//       if (mobile && isPinned) {
//         setIsSidebarVisible(false);
//       } else {
//         setIsSidebarVisible(true);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [isPinned]);

//   useEffect(() => {
//     localStorage.setItem("sidebarPinned", isPinned);
//   }, [isPinned]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobile && !isPinned && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setIsSidebarVisible(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [isMobile, isPinned]);

//   useEffect(() => {
//     if (isMobile && !isPinned) {
//       setIsSidebarVisible(false);
//     }
//   }, [location, isMobile, isPinned]);

//   const handleLogout = async () => {
//     try {
//       const token = localStorage.getItem('token');
//       const sessionId = localStorage.getItem('currentSessionId');
      
//       if (sessionId && token) {
//         try {
//           await fetch(`${BASE_URL}/api/auth/track-logout`, {
//             method: "POST",
//             headers: { 
//               "Content-Type": "application/json",
//               "Authorization": `Bearer ${token}`
//             },
//             credentials: 'include',
//             body: JSON.stringify({ trackingId: parseInt(sessionId) })
//           });
//         } catch (trackError) {
//           console.error("Error tracking logout:", trackError);
//         }
//       }
      
//       localStorage.clear();
//       navigate('/');
      
//     } catch (error) {
//       console.error("Error during logout:", error);
//       localStorage.clear();
//       navigate('/');
//     }
//   };

//   const toggleSidebar = () => {
//     setIsSidebarVisible(!isSidebarVisible);
//   };

//   const toggleSubmenu = (menu) => {
//     setOpenSubmenu(openSubmenu === menu ? null : menu);
//   };

//   const toggleBenchSalesSubmenu = () => {
//     setOpenBenchSalesSubmenu(!openBenchSalesSubmenu);
//   };

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   // Check if current path is recruitment related
//   const isRecruitmentActive = () => {
//     return location.pathname === "/recruitment-dashboard" || 
//            location.pathname === "/recruiter-view" || 
//            location.pathname === "/teamlead-dashboard" ||
//            location.pathname === "/admin-dashboard" ||
//            location.pathname === "/vendor-management";
//   };

//   // Check if current path is ATS related
//   const isATSActive = () => {
//     return location.pathname === "/ats";
//   };

//   // Check if current path is Jobs related
//   const isJobsActive = () => {
//     return location.pathname === "/careers";
//   };

//   // Check if current path is candidate onboarding related
//   const isCandidateOnboardingActive = () => {
//     return location.pathname === "/candidate-onboarding";
//   };

//   // Check if current path is employer related
//   const isEmployerActive = () => {
//     return location.pathname === "/employer-dashboard" || location.pathname === "/employer-form";
//   };

//   const handleRecruitmentClick = () => {
//     if (userRole === "manager" || userRole === "admin") {
//       navigate("/recruitment-dashboard");
//     } else if (userRole === "user" || userRole === "recruiter") {
//       navigate("/recruiter-view");
//     } else if (userRole === "teamlead" || userRole === "team_lead") {
//       navigate("/teamlead-dashboard");
//     } else {
//       navigate("/recruitment-dashboard");
//     }
//   };

//   const handleBenchSalesClick = () => {
//     if (userRole === "manager" || userRole === "admin") {
//       navigate("/bench-sales-dashboard");
//     } else if (userRole === "user") {
//       navigate("/bench-sales-recruiter");
//     } else if (userRole === "teamlead") {
//       navigate("/bench-sales-dashboard");
//     }
//   };

//   const benchSalesMenu = [
//     { path: "/bench-candidates", label: "Candidate Management", icon: <LuUsers size={16} /> },
//     { path: "/bench-requirements", label: "Requirements", icon: <LuFileText size={16} /> },
//     { path: "/bench-submissions", label: "Submissions", icon: <LuSend size={16} /> },
//     { path: "/bench-vendors", label: "Vendors", icon: <LuUsers size={16} /> },
//     { path: "/bench-marketing", label: "Marketing", icon: <LuTarget size={16} /> },
//     { path: "/bench-hotlist", label: "Hotlist", icon: <LuStar size={16} /> },
//   ];

//   const recruitmentSubmenu = [
//     { 
//       path: "/recruitment-dashboard", 
//       label: "Recruitment Dashboard", 
//       icon: <LuLayoutDashboard size={16} />,
//       onClick: handleRecruitmentClick
//     },
//     { 
//       path: "/vendor-management", 
//       label: "Vendor Management", 
//       icon: <LuUsers size={16} />,
//       onClick: () => navigate("/vendor-management")
//     }
//   ];

//   // Check if ATS should be shown
//   const shouldShowATS = ["admin", "super_admin", "manager", "user", "User", "teamlead", "team_lead", "recruiter"].includes(userRole);

//   // Check if Bench Sales should be shown
//   const shouldShowBenchSales = userRole && userRole !== "employee" && !isExternalUser && userRole !== "employer" && userRole !== "candidate";

//   // Check if Jobs should be shown - ONLY for external users
//   const shouldShowJobs = isExternalUser;

//   const shouldShowAccounts = userRole === "admin" || userRole === "account_manager" || userRole === "account-manager";

//   const getMenuItems = () => {
//     // If user is external user, show only Candidate Form
//     if (isExternalUser) {
//       return [
//         { 
//           path: "/ats?candidateForm=true", 
//           label: "Application Form", 
//           icon: <LuBriefcase size={20} />,
//           show: true
//         }
//       ];
//     }

//     // âœ… CANDIDATE VIEW
//     if (userRole === "candidate") {
//       return [
//         { 
//           path: "/candidate-onboarding", 
//           label: "Dashboard", 
//           icon: <LuLayoutDashboard size={20} />,
//           show: true
//         },
//         { 
//           path: "/candidate-onboarding?tab=onboarding", 
//           label: "Onboarding Form", 
//           icon: <LuFilePen size={20} />,
//           show: true,
//           onClick: () => {
//             navigate("/candidate-onboarding", { state: { activeTab: 'onboarding' } });
//           }
//         }
//       ];
//     }

//     // âœ… EMPLOYER VIEW - Dashboard and Company Information
//     if (userRole === "employer") {
//       return [
//         { 
//           path: "/employer-dashboard", 
//           label: "Dashboard", 
//           icon: <LuLayoutDashboard size={20} />,
//           show: true
//         },
//         { 
//           path: "/employer-dashboard", 
//           label: "Company Information", 
//           icon: <LuBuilding size={20} />,
//           show: true,
//           onClick: () => navigate("/employer-dashboard", { state: { employerTab: 'company-info' } })
//         }
//       ];
//     }

//     // Employee view
//     if (userRole === "employee") {
//       const onboardingCompleted = localStorage.getItem('onboardingCompleted') === 'true';
      
//       return [
//         { 
//           path: "/dashboard", 
//           label: "Dashboard", 
//           icon: <LuLayoutDashboard size={20} />,
//           show: true,
//           disabled: false
//         },
//         {
//           label: "Accounts",
//           icon: <LuFileText size={20} />,
//           path: onboardingCompleted ? "/accounts" : "#",
//           show: true,
//           disabled: !onboardingCompleted,
//           locked: !onboardingCompleted,
//           onClick: !onboardingCompleted ? (e) => {
//             e.preventDefault();
//             alert("Please complete your onboarding first to access Accounts.");
//           } : undefined
//         },
//         {
//           label: "Timesheets",
//           icon: <LuClock size={20} />,
//           path: onboardingCompleted ? "/timesheets" : "#",
//           show: true,
//           disabled: !onboardingCompleted,
//           locked: !onboardingCompleted,
//           onClick: !onboardingCompleted ? (e) => {
//             e.preventDefault();
//             alert("Please complete your onboarding first to access Timesheets.");
//           } : undefined
//         },
//         {
//           label: "Invoice",
//           icon: <LuReceipt size={20} />,
//           path: onboardingCompleted ? "/invoices" : "#",
//           show: true,
//           disabled: !onboardingCompleted,
//           locked: !onboardingCompleted,
//           onClick: !onboardingCompleted ? (e) => {
//             e.preventDefault();
//             alert("Please complete your onboarding first to access Invoice.");
//           } : undefined
//         }
//       ];
//     }

//     // For all other roles (admin, manager, hr, etc.) - show full menu
//     const baseItems = [
//       { 
//         path: "/home", 
//         label: "Dashboard", 
//         icon: <LuLayoutDashboard size={20} />,
//         show: true
//       }
//     ];

//     // EMPLOYER MANAGEMENT - for admin/manager/hr to view all employers
//     const employerManagementItem = {
//       path: "/employer-directory",
//       label: "Employer Management",
//       icon: <LuBuilding size={20} />,
//       show: userRole === "admin" || userRole === "manager" || userRole === "hr"
//     };

//     // ONSITE ONBOARDING MENU ITEM
//     const onsiteOnboardingItem = {
//       path: "/onboarding-company",
//       label: "Onboarding",
//       icon: <LuBuilding size={20} />,
//       show: userRole === "admin" || userRole === "manager" || userRole === "hr"
//     };

//     const recruitmentItem = {
//       label: "Recruitment",
//       icon: <LuBriefcase size={20} />,
//       submenu: recruitmentSubmenu,
//       show: userRole === "admin" || userRole === "manager" || userRole === "hr" || userRole === "teamlead" || userRole === "team_lead"
//     };

//     const resumeSubmissionItem = {
//       path: "/resume-dashboard", 
//       label: "Resume Submission", 
//       icon: <LuUserCheck size={20} />,
//       show: userRole === "admin" || userRole === "manager" || userRole === "hr" || userRole === "teamlead" || userRole === "team_lead"
//     };
    
//     const resourceManagementItem = {
//       path: "/resource-management",
//       label: "Resource Management",
//       icon: <LuUsers size={20} />,
//       show: userRole === "admin" || userRole === "manager" || userRole === "teamlead" || userRole === "team_lead"
//     };
    
//     const atsItem = {
//       path: "/ats",
//       label: "ATS",
//       icon: <LuClipboardList size={20} />,
//       show: shouldShowATS
//     };
    
//     const invoiceItem = {
//       label: "Invoice",
//       icon: <LuReceipt size={20} />,
//       path: "/invoices",
//       show: userRole === "admin" || userRole === "manager" || userRole === "account_manager" || userRole === "teamlead" || userRole === "team_lead"
//     };

//     const adminItems = [
//       {
//         label: "Admin",
//         icon: <LuUsers size={20} />,
//         submenu: [
//           {
//             label: "User Management",
//             icon: <LuUsers size={16} />,
//             path: "/user-management",
//             show: userRole === "admin"
//           },
//           // {
//           //   label: "Onboarding Steps",
//           //   icon: <LuUserPlus size={16} />,
//           //   path: "/onboarding-steps",
//           //   show: userRole === "admin"
//           // },
//           // {
//           //   label: "Workflow Display",
//           //   icon: <LuClipboardList size={16} />,
//           //   path: "/workflow-display",
//           //   show: userRole === "admin"
//           // }

//             {
//         label: "MSA",  // ADD THIS NEW MENU ITEM
//         icon: <LuFileText size={16} />,
//         path: "/msa",
//         show: userRole === "admin"
//       }
//         ],
//         show: userRole === "admin"
//       },
//       {
//         label: "Accounting",
//         icon: <LuFileText size={20} />,
//         path: "/companies",
//         show: userRole === "admin" || userRole === "manager" || userRole === "account_manager"
//       }
//     ];

//     return [
//       ...baseItems,
//       recruitmentItem,
//       invoiceItem,
//       resumeSubmissionItem,
//       atsItem,
//       employerManagementItem,
//       onsiteOnboardingItem,
//       resourceManagementItem,
//       ...adminItems.filter(item => item.show)
//     ];
//   };

//   const menuItems = getMenuItems();

//   return (
//     <>
//       {isMobile && (
//         <button
//           className={`sidebar-toggle ${isSidebarVisible ? 'open' : ''}`}
//           onClick={toggleSidebar}
//           aria-label="Toggle sidebar"
//         >
//           {isSidebarVisible ? <LuChevronLeft /> : <LuChevronRight />}
//         </button>
//       )}

//       <div className={`sidebar-overlay ${isMobile && isSidebarVisible ? 'visible' : ''}`} onClick={() => setIsSidebarVisible(false)}></div>

//       <div className="Mainsidebar-container">
//         <div
//           ref={sidebarRef}
//           className={`sidebar ${isExpanded ? "expanded" : "collapsed"} ${isSidebarVisible ? "visible" : "hidden"}`}
//           onMouseEnter={() => !isMobile && !isPinned && setIsHovered(true)}
//           onMouseLeave={() => !isMobile && !isPinned && setIsHovered(false)}
//         >
//           <div className="sidebar-header">
//             <div className="logo-container">
//               <img src={prophecyLogo2} alt="Logo" className="initial-logo" />
//               {isExpanded && <img src={prophecyLogo} alt="Logo" className="logo" />}
//             </div>

//             {isExpanded && !isMobile && (
//               <button className="pin-button" onClick={() => setIsPinned(!isPinned)} aria-label={isPinned ? "Unpin sidebar" : "Pin sidebar"}>
//                 <FaThumbtack className={`pin-icon ${isPinned ? "pinned" : ""}`} />
//               </button>
//             )}

//             {isExpanded && isMobile && (
//               <button className="close-button" onClick={() => setIsSidebarVisible(false)} aria-label="Close sidebar">
//                 <LuChevronLeft />
//               </button>
//             )}
//           </div>

//           <nav>
//             <ul className="menu">
//               {menuItems.map((item, index) => {
//                 if (!item.show) return null;
                
//                 if (item.submenu) {
//                   return (
//                     <React.Fragment key={index}>
//                       <li
//                         className={`menu-item ${openSubmenu === item.label ? "open" : ""} ${item.submenu.some(subItem => isActive(subItem.path)) ? "active" : ""}`}
//                         onClick={() => toggleSubmenu(item.label)}
//                       >
//                         {item.icon}
//                         {isExpanded && <span className="menu-text">{item.label}</span>}
//                         {isExpanded && item.submenu && (
//                           <span className="submenu-icon">
//                             {openSubmenu === item.label ? <FaAngleUp /> : <FaAngleDown />}
//                           </span>
//                         )}
//                         {item.submenu.some(subItem => isActive(subItem.path)) && <span className="active-indicator"></span>}
//                       </li>

//                       {isExpanded && openSubmenu === item.label && (
//                         <ul className="submenu">
//                           {item.submenu.filter(subItem => subItem.show !== false).map((subItem, subIndex) => (
//                             <li
//                               key={subIndex}
//                               className={`submenu-item ${isActive(subItem.path) ? "active" : ""}`}
//                               onClick={subItem.onClick ? subItem.onClick : () => navigate(subItem.path)}
//                             >
//                               <span className="submenu-icon">{subItem.icon}</span>
//                               <span className="submenu-text">{subItem.label}</span>
//                               {isActive(subItem.path) && <span className="active-indicator"></span>}
//                             </li>
//                           ))}
//                         </ul>
//                       )}
//                     </React.Fragment>
//                   );
//                 } else {
//                   // Special handling for candidate menu items
//                   if (userRole === "candidate") {
//                     return (
//                       <li
//                         key={index}
//                         className={`menu-item ${(item.path === "/candidate-onboarding" && location.pathname === "/candidate-onboarding") ? "active" : ""}`}
//                         onClick={() => {
//                           if (item.path === "/candidate-onboarding?tab=onboarding") {
//                             navigate("/candidate-onboarding", { state: { activeTab: 'onboarding' } });
//                           } else {
//                             navigate("/candidate-onboarding");
//                           }
//                         }}
//                       >
//                         {item.icon}
//                         {isExpanded && <span className="menu-text">{item.label}</span>}
//                         {(item.path === "/candidate-onboarding" && location.pathname === "/candidate-onboarding") && <span className="active-indicator"></span>}
//                       </li>
//                     );
//                   } 
//                   // Special handling for employer menu items
//                   else if (userRole === "employer") {
//                     return (
//                       <li
//                         key={index}
//                         className={`menu-item ${(item.path === "/employer-dashboard" && location.pathname === "/employer-dashboard") || 
//                                               (item.path === "/employer-form" && location.pathname === "/employer-form") ? "active" : ""}`}
//                         onClick={() => {
//                           navigate(item.path);
//                         }}
//                       >
//                         {item.icon}
//                         {isExpanded && <span className="menu-text">{item.label}</span>}
//                         {((item.path === "/employer-dashboard" && location.pathname === "/employer-dashboard") || 
//                           (item.path === "/employer-form" && location.pathname === "/employer-form")) && 
//                           <span className="active-indicator"></span>}
//                       </li>
//                     );
//                   } else {
//                     return (
//                       <li
//                         key={index}
//                         className={`menu-item ${item.disabled ? 'disabled' : ''} ${item.onClick && isRecruitmentActive() ? "active" : isActive(item.path) ? "active" : ""}`}
//                         onClick={item.onClick ? item.onClick : item.disabled ? undefined : () => navigate(item.path)}
//                         style={{ cursor: item.disabled ? 'not-allowed' : 'pointer', opacity: item.disabled ? 0.6 : 1 }}
//                       >
//                         {item.icon}
//                         {isExpanded && (
//                           <>
//                             <span className="menu-text">{item.label}</span>
//                             {item.locked && <FaLock size={14} style={{ marginLeft: 'auto' }} />}
//                           </>
//                         )}
//                         {(item.onClick && isRecruitmentActive()) || (item.path === "/ats" && isATSActive()) || (item.path === "/careers" && isJobsActive()) || isActive(item.path) ? <span className="active-indicator"></span> : null}
//                       </li>
//                     );
//                   }
//                 }
//               })}

//               {/* Bench Sales Submenu */}
//               {shouldShowBenchSales && (
//                 <li
//                   className={`menu-item ${openBenchSalesSubmenu ? "open" : ""} ${location.pathname.includes("/bench-") || location.pathname === "/bench-sales" ? "active" : ""}`}
//                   onClick={toggleBenchSalesSubmenu}
//                 >
//                   <LuChartBar size={20} />
//                   {isExpanded && <span className="menu-text">Bench Sales</span>}
//                   {isExpanded && (
//                     <span className="submenu-icon">
//                       {openBenchSalesSubmenu ? <FaAngleUp /> : <FaAngleDown />}
//                     </span>
//                   )}
//                   {(location.pathname.includes("/bench-") || location.pathname === "/bench-sales") && <span className="active-indicator"></span>}
//                 </li>
//               )}
              
//               {shouldShowBenchSales && isExpanded && openBenchSalesSubmenu && (
//                 <ul className="submenu">
//                   <li
//                     className={`submenu-item ${isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter") ? "active" : ""}`}
//                     onClick={handleBenchSalesClick}
//                   >
//                     <span className="submenu-icon"><LuLayoutDashboard size={16} /></span>
//                     <span className="submenu-text">Bench Sales Dashboard</span>
//                     {(isActive("/bench-sales-dashboard") || isActive("/bench-sales-recruiter")) && <span className="active-indicator"></span>}
//                   </li>
//                   {benchSalesMenu.map((item, index) => (
//                     <li
//                       key={index}
//                       className={`submenu-item ${isActive(item.path) ? "active" : ""}`}
//                       onClick={(e) => {
//                         e.preventDefault();
//                         e.stopPropagation();
//                         navigate(item.path);
//                       }}
//                     >
//                       <span className="submenu-icon">{item.icon}</span>
//                       <span className="submenu-text">{item.label}</span>
//                       {isActive(item.path) && <span className="active-indicator"></span>}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </ul>
//           </nav>

//           <div className="settings-section">
//             <ul>
//               {/* Don't show Settings for candidates or employers */}
//               {userRole !== "candidate" && userRole !== "employer" && (
//                 <li className={isActive("/settings") ? "active" : ""} onClick={() => navigate("/settings")}>
//                   <LuSettings size={20} />
//                   {isExpanded && <span className="menu-text">Settings</span>}
//                   {isActive("/settings") && <span className="active-indicator"></span>}
//                 </li>
//               )}
//               <li onClick={handleLogout}>
//                 <LuLogOut size={20} />
//                 {isExpanded && <span className="menu-text">Log Out</span>}
//               </li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sidebar;